<div class="inventory-route">
  <div class="inventory-view-tab-shell">
    <nav class="inventory-view-tabs" aria-label="Inventory sections">
      <button
        type="button"
        class="inventory-view-tab"
        [class.inventory-view-tab--active]="inventorySection === 'pages'"
        (click)="setInventorySection('pages')"
      >
        Pages
      </button>
      <button
        type="button"
        class="inventory-view-tab"
        [class.inventory-view-tab--active]="inventorySection === 'plan'"
        (click)="setInventorySection('plan')"
      >
        Clusters
      </button>
      <button
        type="button"
        class="inventory-view-tab"
        [class.inventory-view-tab--active]="inventorySection === 'actionPlan'"
        (click)="setInventorySection('actionPlan')"
      >
        Action plan
      </button>
      <button
        *ngIf="isActionPlanV2Enabled()"
        type="button"
        class="inventory-view-tab"
        [class.inventory-view-tab--active]="inventorySection === 'planV2'"
        (click)="setInventorySection('planV2')"
      >
        Issues
      </button>
      <button
        *ngIf="isActionPlanV2Enabled()"
        type="button"
        class="inventory-view-tab"
        [class.inventory-view-tab--active]="inventorySection === 'workItems'"
        (click)="setInventorySection('workItems')"
      >
        Work items
        <span class="inventory-view-tab-badge" *ngIf="planV2WorkItems().length">{{ planV2WorkItems().length }}</span>
      </button>
      <button
        type="button"
        class="inventory-view-tab"
        [class.inventory-view-tab--active]="inventorySection === 'cannibalization'"
        (click)="setInventorySection('cannibalization')"
      >
        Cannibalization
      </button>
    </nav>
  </div>

  <ng-container *ngIf="inventorySection === 'plan'">
    <div class="inventory-container inventory-plan-panel">
      <header class="inventory-plan-header">
        <h2 class="inventory-plan-title">Clusters</h2>
        <p class="inventory-plan-lead">
          Add parent topics or <strong>subtopics</strong> to monitor (subtopics are always listed here, even when
          <strong>Include subtopics</strong> is off on Pages). Then use <strong>Pages</strong> to assign URLs to each
          cluster.
        </p>
      </header>

      <p class="plan-topic-loading" *ngIf="planLoading">Loading plan topics…</p>
      <p class="plan-topic-error" *ngIf="planError">{{ planError }}</p>
      <p class="plan-topic-success" *ngIf="planSuccess">{{ planSuccess }}</p>
      <p class="plan-add-topic-error" *ngIf="planAddTopicError" role="alert">{{ planAddTopicError }}</p>

      <div class="plan-empty-boot-actions" *ngIf="!planLoading && planClusters.length === 0">
        <button
          type="button"
          class="btn-primary"
          (click)="bootstrapTopPlanTopics()"
          [disabled]="planBootstrapping || !selectedDomain"
        >
          {{ planBootstrapping ? 'Finding top topics…' : 'Find top topics' }}
        </button>
        <p class="plan-empty-boot-hint">
          Starts from top authority topics and auto-adds current core URLs. You can still add topics manually below.
        </p>
      </div>

      <div class="plan-topic-add-row">
        <label for="plan-topic-filter" class="plan-topic-add-label">Add topic</label>
        <div class="topic-typeahead plan-topic-typeahead">
          <input
            id="plan-topic-filter"
            class="topic-filter-input"
            type="text"
            [ngModel]="planTopicSearchQuery"
            (ngModelChange)="planTopicSearchQuery = $event; onPlanTopicInputChange()"
            (focus)="onPlanTopicInputFocus()"
            (blur)="onPlanTopicInputBlur()"
            (keydown.enter)="applyPlanTopicFromInput(); $event.preventDefault()"
            placeholder="Type to search topics…"
            [disabled]="loadingTopics || !selectedDomain"
            autocomplete="off"
          />
          <div
            class="topic-suggestions plan-topic-suggestions"
            *ngIf="showPlanTopicSuggestions && !loadingTopics && visiblePlanTopicSuggestions.length > 0"
          >
            <button
              type="button"
              class="topic-suggestion"
              *ngFor="let topic of visiblePlanTopicSuggestions"
              (mousedown)="addPlanClusterFromTopic(topic)"
            >
              <span class="topic-suggestion-main">
                <span class="topic-suggestion-label">{{ topic.label }}</span>
                <span class="topic-suggestion-parent" *ngIf="topic.topicType === 'child'">in {{ topic.parentLabel }}</span>
              </span>
              <span class="topic-suggestion-tags">
                <span class="topic-kind-tag" [ngClass]="topicKindTagClass(topic)">
                  {{ topic.topicType === 'child' ? 'Child' : 'Parent' }}
                </span>
                <span class="topic-authority-tag" [ngClass]="topicAuthorityTagClass(topic.authorityScore)">
                  {{ formatAuthorityScore(topic.authorityScore) }}
                </span>
              </span>
            </button>
          </div>
        </div>
        <button
          type="button"
          class="btn-secondary plan-topic-add-btn"
          (click)="applyPlanTopicFromInput()"
          [disabled]="loadingTopics || planLoading || !selectedDomain || !planTopicSearchQuery.trim()"
        >
          Add
        </button>
      </div>
      <p class="plan-topic-loading" *ngIf="loadingTopics">Loading topics…</p>
      <p class="plan-topic-error" *ngIf="!loadingTopics && topicError">{{ topicError }}</p>

      <p class="plan-empty-message" *ngIf="!loadingTopics && !topicError && !planLoading && planClusters.length === 0">
        No topics on your plan yet. Search above — parents and subtopics from Domain Topics are available.
      </p>

      <ul class="plan-cluster-list" *ngIf="!planLoading && planClusters.length > 0">
        <li class="plan-cluster-card" *ngFor="let c of planClusters; trackBy: trackPlanCluster">
          <div class="plan-cluster-card-head">
            <div class="plan-cluster-titles">
              <ng-container *ngIf="editingPlanTopicId !== c.id; else editPlanLabel">
                <span class="plan-cluster-label">{{ c.label }}</span>
              </ng-container>
              <ng-template #editPlanLabel>
                <div class="plan-cluster-label-edit">
                  <input
                    type="text"
                    class="plan-cluster-label-input"
                    [ngModel]="planTopicLabelDraft[c.id] || ''"
                    (ngModelChange)="planTopicLabelDraft[c.id] = $event"
                    (keydown.enter)="savePlanClusterLabel(c); $event.preventDefault()"
                    [disabled]="savingPlanTopicLabelId === c.id"
                  />
                  <button
                    type="button"
                    class="btn-secondary btn-sm"
                    (click)="savePlanClusterLabel(c)"
                    [disabled]="savingPlanTopicLabelId === c.id || !(planTopicLabelDraft[c.id] || '').trim()"
                  >
                    {{ savingPlanTopicLabelId === c.id ? 'Saving…' : 'Save' }}
                  </button>
                  <button
                    type="button"
                    class="btn-secondary btn-sm"
                    (click)="cancelRenamePlanCluster(c.id)"
                    [disabled]="savingPlanTopicLabelId === c.id"
                  >
                    Cancel
                  </button>
                </div>
              </ng-template>
              <span class="plan-cluster-slug">{{ c.topicSlug }}</span>
            </div>
            <span class="plan-cluster-count">{{ c.urls.length }} URL{{ c.urls.length === 1 ? '' : 's' }}</span>
            <button
              type="button"
              class="btn-secondary plan-cluster-rename"
              (click)="beginRenamePlanCluster(c)"
              [disabled]="planLoading || savingPlanTopicLabelId === c.id || editingPlanTopicId === c.id"
            >
              Rename
            </button>
            <button type="button" class="btn-secondary plan-cluster-remove" (click)="removePlanCluster(c.id)" [disabled]="planLoading">
              Remove
            </button>
          </div>

          <div class="plan-cluster-actions">
            <button
              type="button"
              class="btn-primary btn-sm"
              (click)="findUrlsForTopic(c)"
              [disabled]="findingUrlsTopicId === c.id || planLoading"
            >
              {{ findingUrlsTopicId === c.id ? 'Finding URLs…' : 'Find URLs about this topic' }}
            </button>
            <div class="plan-cluster-find-other">
              <div class="topic-typeahead plan-cluster-find-other-typeahead">
                <input
                  type="text"
                  class="plan-cluster-find-other-input"
                  [ngModel]="planFindOtherTopicInput[c.id] || ''"
                  (ngModelChange)="onPlanFindOtherTopicInputChange(c.id, $event)"
                  (focus)="onPlanFindOtherTopicInputFocus(c.id)"
                  (blur)="onPlanFindOtherTopicInputBlur(c.id)"
                  (keydown.enter)="findUrlsForAnotherTopic(c); $event.preventDefault()"
                  placeholder="Find URLs about another topic…"
                  [disabled]="findingUrlsTopicId === c.id || planLoading"
                  autocomplete="off"
                />
                <div
                  class="topic-suggestions plan-cluster-find-other-suggestions"
                  *ngIf="planFindOtherTopicSuggestionsOpen[c.id] && !loadingTopics && visiblePlanOtherTopicSuggestions(c.id).length > 0"
                >
                  <button
                    type="button"
                    class="topic-suggestion"
                    *ngFor="let topic of visiblePlanOtherTopicSuggestions(c.id)"
                    (mousedown)="selectPlanOtherTopicSuggestion(c.id, topic)"
                  >
                    <span class="topic-suggestion-main">
                      <span class="topic-suggestion-label">{{ topic.label }}</span>
                      <span class="topic-suggestion-parent" *ngIf="topic.topicType === 'child'">in {{ topic.parentLabel }}</span>
                    </span>
                    <span class="topic-suggestion-tags">
                      <span class="topic-kind-tag" [ngClass]="topicKindTagClass(topic)">
                        {{ topic.topicType === 'child' ? 'Child' : 'Parent' }}
                      </span>
                      <span class="topic-authority-tag" [ngClass]="topicAuthorityTagClass(topic.authorityScore)">
                        {{ formatAuthorityScore(topic.authorityScore) }}
                      </span>
                    </span>
                  </button>
                </div>
              </div>
              <button
                type="button"
                class="btn-secondary btn-sm"
                (click)="findUrlsForAnotherTopic(c)"
                [disabled]="findingUrlsTopicId === c.id || planLoading || !(planFindOtherTopicInput[c.id] || '').trim()"
              >
                {{ findingUrlsTopicId === c.id ? 'Finding URLs…' : 'Find URLs about another topic' }}
              </button>
            </div>
          </div>

          <div class="table-wrapper plan-cluster-table-wrapper" *ngIf="c.urls.length > 0">
            <table class="inventory-table plan-cluster-table">
              <thead>
                <tr>
                  <th class="plan-col-move-select">
                    <span class="visually-hidden">Select URL to move</span>
                  </th>
                  <th class="col-url">URL</th>
                  <th class="col-score">Score</th>
                  <th class="col-issues">Issues</th>
                  <th class="col-topics">Topics</th>
                  <th class="col-topic-class">
                    <button type="button" class="plan-sort-button" (click)="togglePlanClassSortDirection()">
                      Class {{ planClassSortDirection === 'default' ? '↓' : '↑' }}
                    </button>
                  </th>
                  <th class="col-topic-relevance">Relevance</th>
                  <th class="col-topic-weight">Weight</th>
                  <th class="col-keywords">Keywords</th>
                  <th class="col-traffic">Est. Traffic</th>
                  <th class="plan-col-source">Source</th>
                  <th class="plan-col-action">Action</th>
                </tr>
              </thead>
              <tbody *ngIf="sortedPlanClusterUrls(c) as clusterRows">
                <tr *ngFor="let u of clusterRows; let i = index">
                  <td class="plan-col-move-select">
                    <input
                      type="checkbox"
                      [checked]="isPlanMoveSelected(c.id, u.urlId)"
                      (click)="onPlanMoveCheckboxClick(c.id, clusterRows, i, { urlId: u.urlId, url: u.url }, $event)"
                      [attr.aria-label]="'Select URL to move: ' + u.url"
                    />
                  </td>
                  <td class="col-url" [title]="u.url">
                    <a
                      class="url-text external-link"
                      [href]="u.url"
                      target="_blank"
                      rel="noopener noreferrer"
                      (click)="$event.stopPropagation()"
                    >
                      {{ formatUrl(u.url, true) }}
                      <span class="visually-hidden"> (opens in a new tab)</span>
                    </a>
                  </td>
                  <td class="col-score">
                    <span class="score-badge" [ngClass]="scoreClass((u.onpageScore ?? 0))">
                      {{ u.onpageScore ?? '—' }}
                    </span>
                  </td>
                  <td class="col-issues">
                    <span class="issues-badge issues-badge--icons">
                      <span
                        class="issue-pill issue-pill--critical"
                        *ngIf="(u.criticalIssuesCount || 0) > 0"
                        [title]="(u.criticalIssuesCount || 0) + ' critical issue' + ((u.criticalIssuesCount || 0) === 1 ? '' : 's')"
                      >
                        <span class="issue-pill-icon" aria-hidden="true">⛔</span>
                        <span>{{ u.criticalIssuesCount }}</span>
                      </span>
                      <span
                        class="issue-pill issue-pill--warning"
                        *ngIf="(u.warningsCount || 0) > 0"
                        [title]="(u.warningsCount || 0) + ' warning' + ((u.warningsCount || 0) === 1 ? '' : 's')"
                      >
                        <span class="issue-pill-icon" aria-hidden="true">⚠</span>
                        <span>{{ u.warningsCount }}</span>
                      </span>
                      <span
                        class="issue-pill issue-pill--clean"
                        *ngIf="(u.criticalIssuesCount || 0) === 0 && (u.warningsCount || 0) === 0"
                        title="No critical issues or warnings"
                      >
                        Clean
                      </span>
                    </span>
                  </td>
                  <td class="col-topics">{{ u.topicSignalsCount ?? '—' }}</td>
                  <td class="col-topic-class">
                    <div class="plan-class-cell" data-plan-class-menu-root>
                      <button
                        type="button"
                        class="topic-class-badge plan-class-badge-trigger"
                        [ngClass]="topicClassBadgeClass(u.topicClass)"
                        (click)="togglePlanClassMenu(c.id, u.urlId, $event)"
                        [disabled]="isPlanClassUpdating(c.id, u.urlId)"
                      >
                        {{ topicClassLabel(u.topicClass) }}
                      </button>
                      <div class="plan-class-menu" *ngIf="isPlanClassMenuOpen(c.id, u.urlId)">
                        <button type="button" class="plan-class-menu-item" (click)="updatePlanUrlClass(c, u, 'auto')">Auto</button>
                        <button type="button" class="plan-class-menu-item" (click)="updatePlanUrlClass(c, u, 'core')">Core</button>
                        <button type="button" class="plan-class-menu-item" (click)="updatePlanUrlClass(c, u, 'supporting')">Supporting</button>
                        <button type="button" class="plan-class-menu-item" (click)="updatePlanUrlClass(c, u, 'mention')">Mention</button>
                      </div>
                    </div>
                  </td>
                  <td class="col-topic-relevance">
                    <span class="score-badge" [ngClass]="topicWeightClass(u.topicRelevanceScore)">
                      {{ formatTopicRelevancePct(u.topicRelevancePct) }}
                    </span>
                  </td>
                  <td class="col-topic-weight">
                    <span class="score-badge" [ngClass]="topicWeightClass(u.topicWeight)">
                      {{ formatTopicWeight(u.topicWeight) }}
                    </span>
                  </td>
                  <td class="col-keywords">{{ u.rankedKeywordsCount ?? '—' }}</td>
                  <td class="col-traffic">{{ u.estimatedOrganicTraffic != null ? (u.estimatedOrganicTraffic | number:'1.0-0') : '—' }}</td>
                  <td class="plan-col-source"><span class="plan-cluster-url-source">{{ u.source }}</span></td>
                  <td class="plan-col-action">
                    <button type="button" class="btn-secondary btn-sm" (click)="removeUrlFromCluster(c, u.urlId)">
                      Remove
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="plan-cluster-move-actions" *ngIf="planMoveSelectionCount(c.id) > 0">
            <span class="plan-cluster-move-summary">{{ planMoveSelectionCount(c.id) }} URL{{ planMoveSelectionCount(c.id) === 1 ? '' : 's' }} selected</span>
            <label class="plan-cluster-move-label" [attr.for]="'plan-move-target-' + c.id">Move to cluster</label>
            <select
              class="plan-cluster-move-select"
              [id]="'plan-move-target-' + c.id"
              [ngModel]="planMoveTargetClusterIdBySource[c.id] || ''"
              (ngModelChange)="planMoveTargetClusterIdBySource[c.id] = $event"
              [disabled]="isMovingPlanCluster(c.id)"
            >
              <option value="">Choose destination…</option>
              <option *ngFor="let target of planMoveTargetsForCluster(c.id)" [ngValue]="target.id">{{ target.label }}</option>
            </select>
            <button
              type="button"
              class="btn-primary btn-sm"
              (click)="confirmMoveSelectedUrls(c)"
              [disabled]="isMovingPlanCluster(c.id) || !(planMoveTargetClusterIdBySource[c.id] || '').trim()"
            >
              {{ isMovingPlanCluster(c.id) ? 'Moving…' : 'Move selected' }}
            </button>
            <button
              type="button"
              class="btn-secondary btn-sm"
              (click)="clearPlanMoveSelection(c.id)"
              [disabled]="isMovingPlanCluster(c.id)"
            >
              Clear
            </button>

            <label class="plan-cluster-move-label" [attr.for]="'plan-bulk-class-' + c.id">Set class</label>
            <select
              class="plan-cluster-move-select"
              [id]="'plan-bulk-class-' + c.id"
              [ngModel]="planBulkClassByCluster[c.id] || 'auto'"
              (ngModelChange)="planBulkClassByCluster[c.id] = $event"
              [disabled]="isPlanClassUpdating(c.id)"
            >
              <option value="auto">Auto</option>
              <option value="core">Core</option>
              <option value="supporting">Supporting</option>
              <option value="mention">Mention</option>
            </select>
            <button
              type="button"
              class="btn-secondary btn-sm"
              (click)="updateSelectedPlanUrlsClass(c)"
              [disabled]="isPlanClassUpdating(c.id)"
            >
              {{ isPlanClassUpdating(c.id) ? 'Applying…' : 'Apply class' }}
            </button>
          </div>
          <p class="plan-cluster-urls-empty" *ngIf="c.urls.length === 0">No pages added yet — select rows on Pages and use “Add to cluster…”.</p>

          <div class="plan-cluster-candidates" *ngIf="hasPlanUrlRows(c.id)">
            <p class="plan-cluster-candidates-title">Found URLs (click Add to attach)</p>
            <ul class="plan-candidate-list">
              <li *ngFor="let row of planUrlRows(c.id); trackBy: trackPlanTopicCandidateRow" class="plan-candidate-item">
                <a
                  class="plan-candidate-url external-link"
                  [href]="row.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  [title]="row.url"
                  (click)="$event.stopPropagation()"
                >
                  {{ row.url }}
                  <span class="visually-hidden"> (opens in a new tab)</span>
                </a>
                <span class="topic-class-badge" [ngClass]="topicClassBadgeClass(row.topicClass)">
                  {{ topicClassLabel(row.topicClass) }}
                </span>
                <button
                  type="button"
                  class="btn-secondary btn-sm"
                  (click)="addCandidateUrlToCluster(c, row)"
                  [disabled]="clusterHasUrl(c, row.url)"
                >
                  {{ clusterHasUrl(c, row.url) ? 'Added' : 'Add' }}
                </button>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </ng-container>

  <ng-container *ngIf="inventorySection === 'actionPlan'">
    <div class="inventory-container">
      <header class="inventory-plan-header">
        <h2 class="inventory-plan-title">Action plan</h2>
        <p class="inventory-plan-lead">
          Specific internal-link and cluster-management tasks generated from topic fit, link gaps, and inventory coverage.
        </p>
      </header>

      <div class="action-plan-controls">
        <button type="button" class="btn-secondary btn-sm" (click)="refreshActionPlanSuggestions()" [disabled]="actionPlanLoading || !selectedDomain">
          {{ actionPlanLoading ? 'Refreshing…' : 'Refresh suggestions' }}
        </button>
        <button
          type="button"
          class="btn-secondary btn-sm"
          (click)="exportActionPlanPdf()"
          [disabled]="actionPlanLoading || actionPlanExporting || !selectedDomain || (actionPlanTargetGroups.length === 0 && actionPlanUnclusteredRows.length === 0 && actionPlanClusterSummaries.length === 0)"
        >
          {{ actionPlanExporting ? 'Exporting…' : 'Export PDF' }}
        </button>
        <label class="action-plan-toggle">
          <input type="checkbox" [checked]="actionPlanIncludeDone" (change)="toggleActionPlanIncludeDone()" />
          <span>Show done</span>
        </label>
        <label class="action-plan-toggle">
          <input type="checkbox" [checked]="actionPlanIncludeDismissed" (change)="toggleActionPlanIncludeDismissed()" />
          <span>Show dismissed</span>
        </label>
      </div>

      <p class="plan-topic-loading" *ngIf="actionPlanLoading">Loading action plan suggestions…</p>
      <p class="plan-topic-error" *ngIf="actionPlanError">{{ actionPlanError }}</p>

      <p class="plan-empty-message" *ngIf="!selectedDomain && !actionPlanLoading">
        Select an active domain to view action plan suggestions.
      </p>

      <p class="plan-empty-message" *ngIf="selectedDomain && !actionPlanLoading && !actionPlanError && actionPlanRows.length === 0 && actionPlanUnclusteredRows.length === 0 && actionPlanClusterSummaries.length === 0">
        No action-plan suggestions for current filters.
      </p>

      <section class="action-plan-cluster-overview" *ngIf="!actionPlanLoading && actionPlanClusterSummaries.length > 0">
        <header class="action-plan-cluster-management-head">
          <h3>Cluster overview</h3>
          <p>Cluster structure grouped by role and sorted by estimated traffic.</p>
        </header>
        <table class="action-plan-table-compact action-plan-table-compact--clusters">
          <thead>
            <tr>
              <th>Cluster name</th>
              <th>Core pages</th>
              <th>Supporting pages</th>
            </tr>
          </thead>
          <tbody *ngFor="let cluster of actionPlanClusterSummaries">
            <tr>
              <td>{{ cluster.label }}</td>
              <td>
                <textarea
                  class="action-plan-edit-sentence action-plan-cluster-description"
                  [value]="getActionPlanClusterDescription(cluster)"
                  (input)="onActionPlanClusterDescriptionChange(cluster, $any($event.target).value)"
                  rows="2"
                  placeholder="Description for this cluster (shown in report)"
                ></textarea>
                <div *ngIf="getActionPlanClusterCorePages(cluster).length === 0">—</div>
                <div *ngFor="let page of getActionPlanClusterCorePages(cluster)">
                  <a class="url-text external-link" [href]="page.url" target="_blank" rel="noopener noreferrer">
                    {{ formatUrl(page.url, false) }}
                  </a>
                  <span class="action-plan-traffic-pill">{{ page.estimatedOrganicTraffic | number:'1.0-0' }}</span>
                </div>
              </td>
              <td>
                {{ getActionPlanClusterSupportingPages(cluster).length }} supporting page{{ getActionPlanClusterSupportingPages(cluster).length === 1 ? '' : 's' }} in this cluster
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <section class="action-plan-cluster-management" *ngIf="!actionPlanLoading && actionPlanUnclusteredRows.length > 0">
        <header class="action-plan-cluster-management-head">
          <h3>Cluster management · Unclustered pages</h3>
          <p>Pages not in any cluster, prioritized by traffic and ICP-fit action.</p>
        </header>
        <table class="action-plan-table-compact action-plan-table-compact--clusters">
          <thead>
            <tr>
              <th>URL</th>
              <th>Est. traffic</th>
              <th>Recommendation</th>
              <th>Top topics</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody *ngFor="let row of actionPlanUnclusteredRows; trackBy: trackActionPlanRow">
            <tr>
              <td>
                <a class="url-text external-link" [href]="row.url" target="_blank" rel="noopener noreferrer">
                  {{ formatUrl(row.url, false) }}
                </a>
              </td>
              <td>{{ row.estimatedOrganicTraffic | number:'1.0-0' }}</td>
              <td>
                <input
                  type="text"
                  class="action-plan-edit-input"
                  [value]="getActionPlanEditedRecommendationText(row)"
                  (input)="onActionPlanRecommendationChange(row, $any($event.target).value)"
                />
              </td>
              <td>
                <span *ngIf="row.topTopics.length > 0; else noTopics">{{ row.topTopics.join(', ') }}</span>
                <ng-template #noTopics>—</ng-template>
              </td>
              <td>
                <div class="action-plan-row-actions">
                  <span class="action-plan-status" [ngClass]="actionPlanStatusClass(row.status)">
                    {{ actionPlanStatusLabel(row.status) }}
                  </span>
                  <button
                    *ngIf="row.status !== 'done'"
                    type="button"
                    class="btn-secondary btn-sm"
                    (click)="updateUnclusteredPageSuggestionStatus(row, 'done')"
                    [disabled]="actionPlanUpdatingKey === row.suggestionKey"
                  >
                    Mark done
                  </button>
                  <button
                    *ngIf="row.status !== 'dismissed'"
                    type="button"
                    class="btn-secondary btn-sm"
                    (click)="updateUnclusteredPageSuggestionStatus(row, 'dismissed')"
                    [disabled]="actionPlanUpdatingKey === row.suggestionKey"
                  >
                    Dismiss
                  </button>
                  <button
                    *ngIf="row.status !== 'open'"
                    type="button"
                    class="btn-secondary btn-sm"
                    (click)="updateUnclusteredPageSuggestionStatus(row, 'open')"
                    [disabled]="actionPlanUpdatingKey === row.suggestionKey"
                  >
                    Reopen
                  </button>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="5">
                <div class="action-plan-cluster-rationale">{{ row.rationale }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      <div class="action-plan-groups" *ngIf="!actionPlanLoading && actionPlanRows.length > 0">
        <section class="action-plan-group" *ngFor="let group of actionPlanTargetGroups; trackBy: trackActionPlanTargetGroup">
          <header class="action-plan-group-head">
            <h3 class="action-plan-group-title">
              <span class="action-plan-group-label">Target:</span>
              <a class="url-text external-link" [href]="group.targetUrl" target="_blank" rel="noopener noreferrer">
                {{ formatUrl(group.targetUrl, false) }}
              </a>
            </h3>
            <div class="action-plan-group-meta">
              <span class="score-badge action-plan-metric-pill" [ngClass]="scoreClass(group.maxScore)">Top priority {{ group.maxScore | number:'1.0-0' }}</span>
              <span class="action-plan-metric-pill action-plan-metric-pill--neutral">Est. traffic {{ group.targetTraffic | number:'1.0-0' }}</span>
              <span class="action-plan-metric-pill action-plan-metric-pill--neutral">{{ group.rows.length }} source suggestion{{ group.rows.length === 1 ? '' : 's' }}</span>
              <button
                type="button"
                class="btn-secondary btn-sm"
                (click)="deleteActionPlanTarget(group)"
              >
                Delete
              </button>
              <button
                type="button"
                class="btn-secondary btn-sm action-plan-group-toggle"
                (click)="toggleActionPlanGroupCollapsed(group)"
              >
                {{ isActionPlanGroupCollapsed(group) ? 'Expand' : 'Collapse' }}
              </button>
            </div>
          </header>

          <div class="action-plan-source-list" *ngIf="!isActionPlanGroupCollapsed(group)">
            <table class="action-plan-table-compact">
              <thead>
                <tr>
                  <th>Link from</th>
                  <th>Suggested anchor</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody *ngFor="let row of group.rows; trackBy: trackActionPlanRow">
                <tr>
                  <td>
                    <a class="url-text external-link" [href]="row.sourceUrl" target="_blank" rel="noopener noreferrer">
                      {{ formatUrl(row.sourceUrl, false) }}
                    </a>
                  </td>
                  <td>
                    <input
                      type="text"
                      class="action-plan-edit-input"
                      [value]="getActionPlanEditedAnchor(row)"
                      (input)="onActionPlanAnchorChange(row, $any($event.target).value)"
                      placeholder="Anchor text"
                    />
                    <span class="score-badge action-plan-row-score" [ngClass]="scoreClass(row.score)">
                      {{ row.score | number:'1.0-0' }}
                    </span>
                  </td>
                  <td>
                    <div class="action-plan-row-actions">
                      <span class="action-plan-status" [ngClass]="actionPlanStatusClass(row.status)">
                        {{ actionPlanStatusLabel(row.status) }}
                      </span>
                      <button
                        type="button"
                        class="btn-secondary btn-sm"
                        (click)="toggleActionPlanWhyExpanded(row)"
                      >
                        {{ isActionPlanWhyExpanded(row) ? 'Hide why' : 'Why?' }}
                      </button>
                      <button
                        *ngIf="row.status !== 'dismissed'"
                        type="button"
                        class="btn-secondary btn-sm"
                        (click)="updateActionPlanSuggestionStatus(row, 'dismissed')"
                        [disabled]="actionPlanUpdatingKey === row.suggestionKey"
                      >
                        Dismiss
                      </button>
                      <button
                        *ngIf="row.status === 'dismissed'"
                        type="button"
                        class="btn-secondary btn-sm"
                        (click)="updateActionPlanSuggestionStatus(row, 'open')"
                        [disabled]="actionPlanUpdatingKey === row.suggestionKey"
                      >
                        Reopen
                      </button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="3">
                    <textarea
                      class="action-plan-edit-sentence"
                      [value]="getActionPlanEditedSentence(row)"
                      (input)="onActionPlanSentenceChange(row, $any($event.target).value)"
                      rows="2"
                      placeholder="Example sentence"
                    ></textarea>
                  </td>
                </tr>
                <tr *ngIf="isActionPlanWhyExpanded(row)">
                  <td colspan="3">
                    <div class="action-plan-why-details">
                      <div class="action-plan-where-topic">Matched topic: <strong>{{ row.matchedTopic }}</strong></div>
                      <p class="action-plan-where-rationale" *ngIf="row.where.rationale">{{ row.where.rationale }}</p>
                      <ul class="action-plan-reasons">
                        <li *ngFor="let reason of row.reasons">{{ reason }}</li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="inventorySection === 'planV2' && isActionPlanV2Enabled()">
    <div class="inventory-container inventory-plan-v2-panel">
      <header class="inventory-plan-header">
        <h2 class="inventory-plan-title">Issues</h2>
        <p class="inventory-plan-lead" *ngIf="planV2Summary && !planV2Loading">
          <strong>{{ planV2AttentionCount() }}</strong> URLs need your attention in this queue.
          Expand a row to open the review drawer, dismiss what is not a problem, or
          <button type="button" class="btn-link-inline" (click)="openWorkItemsTab()">send cards to Work items</button>.
        </p>
        <p class="inventory-plan-lead muted" *ngIf="!planV2Summary && !planV2Loading">
          Review synthesized findings per URL. Send actionable cards to Work items for execution.
        </p>
      </header>

      <div class="action-plan-controls plan-v2-queue-controls">
        <button
          type="button"
          class="btn-secondary btn-sm"
          (click)="loadPlanV2()"
          [disabled]="planV2Loading || !selectedDomain"
        >
          {{ planV2Loading ? 'Refreshing…' : 'Refresh' }}
        </button>
        <button
          type="button"
          class="btn-secondary btn-sm"
          (click)="planV2RegenerateQueue()"
          [disabled]="planV2Regenerating || planV2TriagePersistedCount() === 0 || !selectedDomain"
          title="Hard reset: clear ignored URLs, dismissed cards, and all work items for this domain"
        >
          {{ planV2Regenerating ? 'Regenerating…' : 'Regenerate queue' }}
        </button>
        <label class="plan-v2-actions-only-toggle">
          <input type="checkbox" [(ngModel)]="planV2ActionsOnly" />
          Actions only
        </label>
        <label class="plan-v2-actions-only-toggle" *ngIf="planV2IgnoredRows().length > 0">
          <input type="checkbox" [(ngModel)]="planV2ShowIgnored" />
          Show ignored ({{ planV2IgnoredRows().length }})
        </label>
      </div>

      <p class="plan-topic-loading" *ngIf="planV2Loading">Loading Plan v2…</p>
      <p class="plan-topic-error" *ngIf="planV2Error">{{ planV2Error }}</p>

      <section class="plan-v2-summary" *ngIf="planV2Summary && !planV2Loading" aria-label="Executive summary">
        <div class="plan-v2-summary-head">
          <h3 class="plan-v2-summary-title">Executive summary</h3>
          <span class="plan-v2-summary-queue muted">
            Open queue
            <strong>{{ planV2AttentionCount() }}</strong>
            / {{ planV2Summary.totalUrlsInPool }} in pool
            <span *ngIf="planV2IgnoredRows().length"> · {{ planV2IgnoredRows().length }} ignored</span>
          </span>
        </div>
        <div class="plan-v2-summary-stats">
          <span class="plan-v2-stat"><span class="plan-v2-stat-tier">P0</span> Technical <strong>{{ planV2Summary.p0Technical }}</strong></span>
          <span class="plan-v2-stat"><span class="plan-v2-stat-tier">P1</span> Consolidate <strong>{{ planV2Summary.p1Consolidate }}</strong></span>
          <span class="plan-v2-stat"><span class="plan-v2-stat-tier">P2</span> Gap <strong>{{ planV2Summary.p2Gap }}</strong></span>
          <span class="plan-v2-stat"><span class="plan-v2-stat-tier">P3</span> Intent <strong>{{ planV2Summary.p3Intent }}</strong></span>
          <span class="plan-v2-stat"><span class="plan-v2-stat-tier">P4</span> Links <strong>{{ planV2Summary.p4Links }}</strong></span>
          <span class="plan-v2-stat"><span class="plan-v2-stat-tier">P5</span> Cluster <strong>{{ planV2Summary.p5Cluster }}</strong></span>
        </div>
        <p class="plan-v2-summary-themes" *ngIf="planV2Summary.themes?.length">
          <span class="plan-v2-theme" *ngFor="let theme of planV2Summary.themes">{{ theme }}</span>
        </p>
      </section>

      <p class="plan-empty-message" *ngIf="!planV2Loading && !planV2Error && planV2Rows.length === 0 && selectedDomain">
        No open synthesis items for this domain.
      </p>

      <p
        class="plan-empty-message"
        *ngIf="!planV2Loading && !planV2Error && planV2Rows.length > 0 && planV2ActiveRows().length === 0"
      >
        All URLs on this page are ignored.
        <button type="button" class="btn-link-inline" (click)="planV2ShowIgnored = true">Show ignored</button>
        or use <strong>Regenerate queue</strong> to hard-reset triage (including work items).
      </p>

      <div class="table-wrapper table-wrapper--pages-sticky" *ngIf="!planV2Loading && planV2ActiveRows().length > 0">
        <table class="action-plan-table-compact plan-v2-table">
          <thead>
            <tr>
              <th>Priority</th>
              <th>URL</th>
              <th>Recommended action</th>
              <th>Signals</th>
              <th>Gap / health</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let row of planV2ActiveRows(); trackBy: trackPlanV2Row">
              <tr
                class="plan-v2-row"
                [class.plan-v2-row--ignoring]="planV2IgnoringUrlId === row.urlId"
                [class.plan-v2-row--drawer-open]="isPlanV2DrawerOpenFor(row)"
              >
                <td>
                  <span class="score-badge" [ngClass]="scoreClass(row.priorityScore)">{{ row.priorityScore | number:'1.0-0' }}</span>
                </td>
                <td class="plan-v2-url-cell" [title]="row.url">{{ row.url }}</td>
                <td>
                  <strong>{{ row.recommendedAction.label }}</strong>
                </td>
                <td>
                  <span
                    *ngFor="let kind of row.signalTypes"
                    class="page-signal-chip"
                    [ngClass]="pageSignalChipClass(kind)"
                  >{{ planV2SignalLabel(kind) }}</span>
                </td>
                <td>
                  <span class="health-pill" [ngClass]="planV2HealthClass(row.metrics.effectiveHealth)">{{ row.metrics.effectiveHealth }}</span>
                  <span class="muted plan-v2-gap" *ngIf="row.metrics.realizationGap !== null">
                    Gap {{ row.metrics.realizationGap | number:'1.0-0' }}
                  </span>
                </td>
                <td class="plan-v2-row-actions">
                  <button type="button" class="btn-secondary btn-sm" (click)="togglePlanV2Drawer(row, $event)">
                    {{ isPlanV2DrawerOpenFor(row) ? 'Close' : 'Expand' }}
                  </button>
                  <button type="button" class="btn-secondary btn-sm" (click)="planV2OpenUrlDetail(row, $event)">URL detail</button>
                  <button
                    type="button"
                    class="btn-secondary btn-sm plan-v2-ignore-btn"
                    (click)="planV2IgnoreUrl(row, $event)"
                    [disabled]="planV2IgnoringUrlId === row.urlId"
                    title="Hide this URL from the queue (restore via Show ignored or Regenerate queue)"
                  >
                    Ignore URL
                  </button>
                </td>
              </tr>
            </ng-container>
            <ng-container *ngIf="planV2ShowIgnored && planV2IgnoredRows().length > 0">
              <tr class="plan-v2-ignored-divider">
                <td colspan="6">Ignored URLs — hidden until restored</td>
              </tr>
              <tr *ngFor="let row of planV2IgnoredRows(); trackBy: trackPlanV2Row" class="plan-v2-row plan-v2-row--ignored">
                <td>
                  <span class="score-badge score-muted">{{ row.priorityScore | number:'1.0-0' }}</span>
                </td>
                <td class="plan-v2-url-cell" [title]="row.url">{{ row.url }}</td>
                <td colspan="3" class="muted">Ignored — expand findings are paused for this URL</td>
                <td class="plan-v2-row-actions">
                  <button type="button" class="btn-secondary btn-sm" (click)="planV2RestoreIgnoredUrl(row, $event)">
                    Restore
                  </button>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <nav class="plan-v2-pagination" *ngIf="planV2Meta && planV2Meta.totalPages > 1" aria-label="Plan v2 pagination">
        <button type="button" class="btn-secondary btn-sm" [disabled]="planV2Page <= 1" (click)="planV2GoToPage(planV2Page - 1)">Previous</button>
        <span class="muted">Page {{ planV2Meta.page }} of {{ planV2Meta.totalPages }}</span>
        <button
          type="button"
          class="btn-secondary btn-sm"
          [disabled]="planV2Page >= planV2Meta.totalPages"
          (click)="planV2GoToPage(planV2Page + 1)"
        >Next</button>
      </nav>
    </div>
  </ng-container>

  <!-- Issues review drawer: must stay outside `pages` *ngIf or it is not in the DOM on Issues tab. -->
  <div class="plan-v2-drawer-root" *ngIf="planV2DrawerRow as drawerRowGlobal">
    <button
      type="button"
      class="plan-v2-drawer-scrim"
      aria-label="Close review drawer"
      (click)="closePlanV2Drawer()"
    ></button>
    <aside
      class="plan-v2-drawer-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="plan-v2-drawer-title-global"
      (click)="$event.stopPropagation()"
    >
      <header class="plan-v2-drawer-header">
        <div class="plan-v2-drawer-header-text">
          <h3 id="plan-v2-drawer-title-global" class="plan-v2-drawer-title">Review URL</h3>
          <a
            class="plan-v2-drawer-url"
            [href]="drawerRowGlobal.url"
            target="_blank"
            rel="noopener noreferrer"
            [title]="drawerRowGlobal.url"
            >{{ drawerRowGlobal.url }}</a
          >
          <p class="plan-v2-drawer-meta muted">
            <strong>{{ drawerRowGlobal.recommendedAction.label }}</strong>
            · Priority {{ drawerRowGlobal.priorityScore | number:'1.0-0' }}
          </p>
        </div>
        <div class="plan-v2-drawer-header-actions">
          <button type="button" class="btn-secondary btn-sm" (click)="planV2OpenUrlDetail(drawerRowGlobal, $event)">
            URL detail
          </button>
          <button
            type="button"
            class="btn-secondary btn-sm plan-v2-ignore-btn"
            (click)="planV2IgnoreUrl(drawerRowGlobal, $event)"
            [disabled]="planV2IgnoringUrlId === drawerRowGlobal.urlId"
            title="Hide this URL from the queue (restore via Show ignored or Regenerate queue)"
          >
            Ignore URL
          </button>
          <button type="button" class="btn-secondary btn-sm" (click)="closePlanV2Drawer()">Close</button>
        </div>
      </header>
      <div class="plan-v2-drawer-body">
        <app-url-detail
          [embedUrl]="drawerRowGlobal.url"
          embedPreset="planV2"
          [embedPlanV2InDrawer]="true"
          [embedActionsOnly]="planV2ActionsOnly"
          [embedPlanV2Domain]="selectedDomain"
          [embedPlanV2Row]="drawerRowGlobal"
        ></app-url-detail>
      </div>
    </aside>
  </div>

  <ng-container *ngIf="inventorySection === 'workItems' && isActionPlanV2Enabled()">
    <div class="inventory-container inventory-work-items-panel">
      <header class="inventory-plan-header">
        <h2 class="inventory-plan-title">Work items</h2>
        <p class="inventory-plan-lead">
          Accepted issues grouped by page — open a URL in your CMS and work through its tasks in one pass.
          New items appear here as you triage Issues.
        </p>
      </header>

      <div class="action-plan-controls">
        <button
          type="button"
          class="btn-secondary btn-sm"
          (click)="loadPlanV2IssueDispositions()"
          [disabled]="planV2IssuesLoading || !selectedDomain"
        >
          {{ planV2IssuesLoading ? 'Refreshing…' : 'Refresh' }}
        </button>
        <button
          type="button"
          class="btn-secondary btn-sm"
          (click)="exportWorkItemsPdf()"
          [disabled]="workItemsExporting || planV2WorkItems().length === 0"
        >
          {{ workItemsExporting ? 'Exporting…' : 'Export PDF' }}
        </button>
        <button type="button" class="btn-link-inline" (click)="setInventorySection('planV2')">Back to Issues</button>
      </div>

      <section
        class="plan-v2-summary work-items-recap"
        *ngIf="planV2WorkItems().length > 0 && planV2WorkItemsRecap().length"
        aria-label="Work items recap"
      >
        <div class="plan-v2-summary-head">
          <h3 class="plan-v2-summary-title">Recap</h3>
          <span class="plan-v2-summary-queue muted">
            <strong>{{ planV2WorkItems().length }}</strong>
            task{{ planV2WorkItems().length === 1 ? '' : 's' }} across
            <strong>{{ planV2WorkItemsByUrl().length }}</strong>
            page{{ planV2WorkItemsByUrl().length === 1 ? '' : 's' }}
          </span>
        </div>
        <div class="plan-v2-summary-stats">
          <span class="plan-v2-stat" *ngFor="let line of planV2WorkItemsRecap()">
            <strong>{{ line.count }}</strong> {{ line.text }}
          </span>
        </div>
      </section>

      <p class="plan-empty-message" *ngIf="!planV2IssuesLoading && planV2WorkItems().length === 0">
        No work items yet. On the Issues tab, expand a URL and use <strong>Add to work items</strong> on a card.
      </p>

      <div class="work-items-list" *ngIf="planV2WorkItems().length > 0">
        <section
          class="work-items-url-group"
          *ngFor="let group of planV2WorkItemsByUrl(); trackBy: trackWorkItemGroup"
        >
          <header class="work-items-url-group-head">
            <div class="work-items-url-group-title">
              <h3 class="work-items-url-group-url">
                <a [href]="group.url" target="_blank" rel="noopener noreferrer">{{ group.url }}</a>
              </h3>
              <span class="work-items-url-group-meta muted">
                {{ group.items.length }} task{{ group.items.length === 1 ? '' : 's' }}
              </span>
            </div>
            <div class="work-items-url-group-actions">
              <span class="score-badge" *ngIf="group.priorityScore > 0">{{ group.priorityScore | number:'1.0-0' }}</span>
              <button type="button" class="btn-secondary btn-sm" (click)="openUrlDetailForUrl(group.url, $event)">
                URL detail
              </button>
            </div>
          </header>
          <article
            class="work-item-card work-item-card--nested"
            *ngFor="let item of group.items; trackBy: trackWorkItem"
            [class.work-item-card--returning]="workItemReturningKey === item.issueKey"
          >
            <app-plan-v2-work-item-body [item]="item" />
            <div class="work-item-card-actions">
              <button
                type="button"
                class="btn-secondary btn-sm"
                (click)="returnWorkItemToIssues(item, $event)"
                [disabled]="workItemReturningKey === item.issueKey"
              >
                Back to issues
              </button>
            </div>
          </article>
        </section>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="inventorySection === 'cannibalization'">
    <div class="inventory-container">
      <header class="inventory-plan-header">
        <h2 class="inventory-plan-title">Cannibalization</h2>
        <p class="inventory-plan-lead">
          For each <strong>weaker page</strong> (lower estimated traffic), suggested <strong>stronger URLs</strong> you could consolidate into—ranked-keyword overlap, on-page similarity, topics, and traffic split.
          Run ranked-keyword backfill first for reliable overlap signals.
        </p>
      </header>

      <div class="action-plan-controls">
        <button
          type="button"
          class="btn-secondary btn-sm"
          (click)="refreshCannibalSuggestions()"
          [disabled]="cannibalLoading || cannibalResetting || !selectedDomain"
          title="Clears every cannibalization decision for this domain (merge / delete / keep / dismiss), then reloads suggestions from scratch."
        >
          {{ cannibalResetting ? 'Resetting…' : cannibalLoading ? 'Loading…' : 'Refresh all' }}
        </button>
        <button
          type="button"
          class="btn-secondary btn-sm"
          (click)="runRankedKeywordsBackfill()"
          [disabled]="cannibalRankedKwRunning || cannibalResetting || !selectedDomain"
        >
          {{ cannibalRankedKwRunning ? 'Backfilling…' : 'Backfill ranked keywords' }}
        </button>
        <button
          type="button"
          class="btn-secondary btn-sm"
          (click)="exportCannibalizationPdf()"
          [disabled]="cannibalLoading || cannibalExporting || cannibalResetting || !selectedDomain || cannibalRowsWorklist.length === 0"
        >
          {{ cannibalExporting ? 'Exporting…' : 'Export PDF' }}
        </button>
        <label class="action-plan-toggle">
          <input type="checkbox" [checked]="cannibalIncludeDismissed" (change)="toggleCannibalIncludeDismissed()" />
          <span>Show dismissed</span>
        </label>
        <label class="action-plan-toggle" title="Uses DataForSEO Labs Page Intersection (extra cost per pair, capped server-side).">
          <input type="checkbox" [checked]="cannibalIncludePageIntersection" (change)="toggleCannibalPageIntersection()" />
          <span>Labs page intersection</span>
        </label>
        <label
          class="action-plan-toggle"
          title="When on, hides review-grade pairs (structural/page overlap without shared ranked keywords). Merge-grade pairs drive consolidate recommendations."
        >
          <input type="checkbox" [checked]="cannibalMergeGradeOnly" (change)="toggleCannibalMergeGradeOnly()" />
          <span>Merge-grade only</span>
        </label>
      </div>

      <div class="path-prefix-filter cannibal-path-exclude" *ngIf="selectedDomain">
        <span class="path-prefix-label">Exclude paths</span>
        <p class="path-prefix-hint">
          Optional. Hides a pair if <strong>either</strong> URL is under a selected path (OR). Same path segments as <strong>Pages → Path</strong> (Homepage, Top-level, /blog, …). Useful to drop noisy folders such as <strong>/templates</strong>.
        </p>
        <div class="path-prefix-chips">
          <button
            type="button"
            class="path-prefix-chip"
            *ngFor="let p of primaryPathChipOptions()"
            [class.path-prefix-chip--active]="isCannibalExcludePathSelected(p)"
            (click)="toggleCannibalExcludePathPrefix(p)"
          >
            {{ pathPrefixChipLabel(p) }}
          </button>
        </div>
        <span class="path-prefix-status" *ngIf="loadingPathPrefixes">Loading paths…</span>
        <span class="path-prefix-status path-prefix-error" *ngIf="!loadingPathPrefixes && pathPrefixError">{{ pathPrefixError }}</span>
        <p class="cannibal-path-exclude-meta" *ngIf="cannibalRows.length > 0">
          Showing {{ cannibalRowsFiltered.length }} of {{ cannibalRows.length }} suggestions across
          {{ cannibalGroupsByLoser.length }} weaker URL{{ cannibalGroupsByLoser.length === 1 ? '' : 's' }}
          <ng-container *ngIf="cannibalMergeGradeOnly"> (merge-grade only)</ng-container>.
        </p>
      </div>

      <div
        class="cannibal-rkw-progress"
        *ngIf="cannibalRankedKwRunning && cannibalRankedKwProgress"
        role="status"
        aria-live="polite"
      >
        <div class="cannibal-rkw-progress-bar-wrap">
          <div class="cannibal-rkw-progress-bar">
            <div class="cannibal-rkw-progress-fill" [style.width.%]="cannibalRankedKwProgress.percent"></div>
          </div>
        </div>
        <div class="cannibal-rkw-progress-meta">
          <span class="cannibal-rkw-progress-line">{{ cannibalRankedKwProgress.statusLine }}</span>
          <span class="cannibal-rkw-eta" *ngIf="cannibalRankedKwProgress.etaLabel">{{ cannibalRankedKwProgress.etaLabel }}</span>
        </div>
      </div>

      <p class="plan-topic-loading" *ngIf="cannibalLoading">Loading cannibalization suggestions…</p>
      <p class="plan-topic-error" *ngIf="cannibalError">{{ cannibalError }}</p>

      <p class="plan-empty-message" *ngIf="!selectedDomain && !cannibalLoading">
        Select an active domain to view cannibalization suggestions.
      </p>

      <p class="plan-empty-message" *ngIf="selectedDomain && !cannibalLoading && !cannibalError && cannibalRows.length === 0">
        No cannibalization pairs matched current thresholds. Try backfilling ranked keywords or lowering overlap filters on the backend.
      </p>

      <p
        class="plan-empty-message"
        *ngIf="selectedDomain && !cannibalLoading && !cannibalError && cannibalRows.length > 0 && cannibalRowsFiltered.length === 0"
      >
        No pairs match the current filters. Turn off <strong>Merge-grade only</strong> to see structural-overlap (review) pairs, or clear
        <strong>Exclude paths</strong> chips.
      </p>

      <p
        class="plan-empty-message"
        *ngIf="selectedDomain && !cannibalLoading && !cannibalError && cannibalRowsFiltered.length > 0 && cannibalRowsWorklist.length === 0"
      >
        No active suggestions in the current view (every pair may be dismissed — use <strong>Show dismissed</strong> to reopen, or
        clear path filters).
      </p>

      <div class="cannibal-loser-stack" *ngIf="!cannibalLoading && cannibalGroupsByLoser.length > 0">
        <section class="cannibal-loser-card" *ngFor="let grp of cannibalGroupsByLoser; trackBy: trackCannibalLoserGroup">
          <div class="cannibal-loser-card__header">
            <div class="cannibal-loser-card__title-block">
              <h3 class="cannibal-loser-card__heading">Weaker URL</h3>
              <a
                class="url-text external-link cannibal-loser-card__url"
                [href]="grp.loserUrl"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ formatUrl(grp.loserUrl, false) }}
              </a>
              <span class="action-plan-metric-pill action-plan-metric-pill--neutral cannibal-loser-card__traffic">
                Est. traffic {{ grp.trafficLow | number:'1.0-0' }}
              </span>
              <span
                *ngIf="grp.targets[0]?.signals?.loserRankedKeywordsCount != null"
                class="action-plan-metric-pill action-plan-metric-pill--neutral"
                title="Ranked keywords (stored rows for this URL)"
              >
                Ranked KW {{ grp.targets[0].signals.loserRankedKeywordsCount | number:'1.0-0' }}
              </span>
              <span
                role="button"
                tabindex="0"
                class="action-plan-metric-pill cannibal-backlinks-pill"
                [ngClass]="{
                  'cannibal-backlinks-pill--highlight': environment.featureFlags.cannibalBacklinksPreviewHighlight,
                  'action-plan-metric-pill--neutral': !environment.featureFlags.cannibalBacklinksPreviewHighlight
                }"
                aria-label="External backlinks: coming soon. Hover for details."
                (mouseenter)="openCannibalBacklinksPopover($event)"
                (mouseleave)="scheduleCannibalBacklinksPopoverHide()"
                (focusin)="openCannibalBacklinksPopover($event)"
                (focusout)="scheduleCannibalBacklinksPopoverHide()"
                (click)="$event.stopPropagation(); openCannibalBacklinksPopover($event)"
              >
                Backlinks —
              </span>
              <ng-container *ngFor="let cl of grp.loserClusterLabels">
                <span class="action-plan-metric-pill action-plan-metric-pill--neutral" title="Workspace Plan cluster (Inventory → Plan)">{{
                  cl
                }}</span>
              </ng-container>
              <span
                *ngIf="grp.loserClusterLabels.length === 0"
                class="action-plan-metric-pill action-plan-metric-pill--neutral"
                title="This URL is not in any workspace Plan cluster yet"
                >Cluster —</span
              >
              <ng-container *ngIf="cannibalIncomingState(grp.loserUrlId).loading">
                <span class="action-plan-metric-pill action-plan-metric-pill--neutral">…</span>
              </ng-container>
              <ng-container *ngIf="!cannibalIncomingState(grp.loserUrlId).loading && cannibalIncomingState(grp.loserUrlId).error">
                <span
                  class="action-plan-metric-pill action-plan-metric-pill--neutral"
                  [attr.title]="cannibalIncomingState(grp.loserUrlId).error"
                  >— links</span
                >
              </ng-container>
              <ng-container *ngIf="!cannibalIncomingState(grp.loserUrlId).loading && !cannibalIncomingState(grp.loserUrlId).error">
                <span
                  role="button"
                  tabindex="0"
                  class="action-plan-metric-pill action-plan-metric-pill--neutral cannibal-incoming-pill"
                  [attr.aria-label]="'Contextual incoming internal links: ' + (cannibalIncomingState(grp.loserUrlId).metadata?.contextualLinks ?? 0)"
                  (mouseenter)="openCannibalIncomingPopover('contextual', grp.loserUrlId, $event)"
                  (mouseleave)="scheduleCannibalIncomingPopoverHide()"
                  (focusin)="openCannibalIncomingPopover('contextual', grp.loserUrlId, $event)"
                  (focusout)="scheduleCannibalIncomingPopoverHide()"
                  (click)="$event.stopPropagation(); openCannibalIncomingPopover('contextual', grp.loserUrlId, $event)"
                >
                  {{ cannibalIncomingState(grp.loserUrlId).metadata?.contextualLinks ?? 0 }} contextual links
                </span>
                <span
                  role="button"
                  tabindex="0"
                  class="action-plan-metric-pill action-plan-metric-pill--neutral cannibal-incoming-pill"
                  [attr.aria-label]="'Structural incoming internal links: ' + (cannibalIncomingState(grp.loserUrlId).metadata?.structuralLinks ?? 0)"
                  (mouseenter)="openCannibalIncomingPopover('structural', grp.loserUrlId, $event)"
                  (mouseleave)="scheduleCannibalIncomingPopoverHide()"
                  (focusin)="openCannibalIncomingPopover('structural', grp.loserUrlId, $event)"
                  (focusout)="scheduleCannibalIncomingPopoverHide()"
                  (click)="$event.stopPropagation(); openCannibalIncomingPopover('structural', grp.loserUrlId, $event)"
                >
                  {{ cannibalIncomingState(grp.loserUrlId).metadata?.structuralLinks ?? 0 }} structural links
                </span>
              </ng-container>
              <span class="cannibal-loser-card__meta">{{ cannibalGroupTargetMeta(grp) }}</span>
            </div>
          </div>

          <h4 class="cannibal-targets-heading">{{ cannibalStrongerPagesHeading(grp) }}</h4>
          <div class="cannibal-table-wrap cannibal-table-wrap--nested">
            <table class="action-plan-table-compact cannibal-table">
              <thead>
                <tr>
                  <th>{{ cannibalWinnerColumnHeader(grp) }}</th>
                  <th>Grade</th>
                  <th>Score</th>
                  <th>Ranked KW</th>
                  <th>Shared KW</th>
                  <th>Traffic (high vs low)</th>
                  <th>Cluster</th>
                  <th>Jaccard overlap</th>
                  <th>Decision</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let row of grp.targets; trackBy: trackCannibalRow">
                  <tr>
                    <td>
                      <a
                        *ngIf="cannibalShowStrongerUrlColumn(row)"
                        class="url-text external-link"
                        [href]="cannibalWinnerUrl(row)"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ formatUrl(cannibalWinnerUrl(row), false) }}
                      </a>
                      <span *ngIf="!cannibalShowStrongerUrlColumn(row)" class="cannibal-decision-na" title="No merge target for this decision">
                        —
                      </span>
                    </td>
                    <td>
                      <span
                        class="cannibal-grade-pill"
                        [class.cannibal-grade-pill--merge]="row.signals.mergeGrade === 'merge'"
                        [class.cannibal-grade-pill--review]="row.signals.mergeGrade === 'review'"
                        [attr.title]="cannibalQualificationTitle(row)"
                        >{{ cannibalMergeGradeLabel(row) }}</span
                      >
                      <span
                        class="cannibal-grade-flag"
                        *ngIf="row.signals.templateFamily"
                        title="Parallel pages under the same path segment with skeleton overlap"
                        >Template</span
                      >
                    </td>
                    <td>
                      <span class="score-badge" [ngClass]="scoreClass(row.score)">{{ row.score | number:'1.0-0' }}</span>
                    </td>
                    <td>{{ row.signals.winnerRankedKeywordsCount | number:'1.0-0' }}</td>
                    <td>{{ row.signals.sharedKeywordsCount }}</td>
                    <td class="cannibal-winner-cell">
                      <span class="action-plan-metric-pill action-plan-metric-pill--neutral">
                        {{ row.signals.trafficHigh | number:'1.0-0' }} vs {{ row.signals.trafficLow | number:'1.0-0' }}
                      </span>
                    </td>
                    <td class="cannibal-cluster-cell" [attr.title]="formatCannibalClusterCell(row.signals.winnerUrlId)">
                      {{ formatCannibalClusterCell(row.signals.winnerUrlId) }}
                    </td>
                    <td class="cannibal-jaccard-cell" [attr.title]="cannibalJaccardTitle(row)">
                      {{ (row.signals.uniqueContentTokenJaccard ?? row.signals.contentTokenJaccard) | percent:'1.0-1' }}
                    </td>
                    <td class="cannibal-row-actions cannibal-row-actions--decision">
                      <ng-container *ngIf="row.status === 'done' && row.cannibalResolution">
                        <span
                          class="cannibal-row-decision-pill"
                          [class.cannibal-row-decision-pill--delete]="row.cannibalResolution === 'delete'"
                          [class.cannibal-row-decision-pill--merge]="row.cannibalResolution === 'merge_redirect'"
                          [class.cannibal-row-decision-pill--keep]="row.cannibalResolution === 'keep_improve'"
                          [attr.title]="cannibalDecisionRecordedTitle(row)"
                          >{{ cannibalRowDecisionShortLabel(row) }}</span
                        >
                        <button type="button" class="btn-secondary btn-sm cannibal-row-detail-btn" (click)="toggleCannibalExpanded(row)">
                          {{ isCannibalExpanded(row) ? 'Hide' : 'Detail' }}
                        </button>
                      </ng-container>
                      <ng-container *ngIf="row.status === 'done' && !row.cannibalResolution">
                        <span class="cannibal-row-decision-pill cannibal-row-decision-pill--neutral">Done</span>
                        <button type="button" class="btn-secondary btn-sm cannibal-row-detail-btn" (click)="toggleCannibalExpanded(row)">
                          {{ isCannibalExpanded(row) ? 'Hide' : 'Detail' }}
                        </button>
                      </ng-container>
                      <ng-container *ngIf="row.status === 'open'">
                        <button type="button" class="btn-secondary btn-sm" (click)="toggleCannibalExpanded(row)">
                          {{ isCannibalExpanded(row) ? 'Hide detail' : 'Detail' }}
                        </button>
                        <button
                          type="button"
                          class="btn-secondary btn-sm"
                          (click)="updateCannibalSuggestionStatus(row, 'dismissed')"
                          [disabled]="cannibalUpdatingKey === row.suggestionKey"
                        >
                          Dismiss
                        </button>
                      </ng-container>
                      <ng-container *ngIf="row.status === 'dismissed'">
                        <span class="cannibal-row-decision-pill cannibal-row-decision-pill--neutral">Dismissed</span>
                      </ng-container>
                    </td>
                  </tr>
                  <tr *ngIf="isCannibalExpanded(row)" class="cannibal-detail-row">
                    <td colspan="8">
                      <div class="cannibal-detail-grid">
                        <div class="cannibal-detail-col">
                          <h4 class="cannibal-detail-label">Weaker page</h4>
                          <p class="cannibal-detail-title"><strong>{{ cannibalLoserPreview(row).title || '—' }}</strong></p>
                          <p class="cannibal-snippet">{{ cannibalLoserPreview(row).snippet || '—' }}</p>
                          <ul class="cannibal-headings" *ngIf="cannibalLoserPreview(row).headings?.length">
                            <li *ngFor="let h of cannibalLoserPreview(row).headings.slice(0, 8)">{{ h }}</li>
                          </ul>
                        </div>
                        <div class="cannibal-detail-col" *ngIf="cannibalShowStrongerUrlColumn(row)">
                          <h4 class="cannibal-detail-label">Stronger page (this candidate)</h4>
                          <p class="cannibal-detail-title"><strong>{{ cannibalWinnerPreview(row).title || '—' }}</strong></p>
                          <p class="cannibal-snippet">{{ cannibalWinnerPreview(row).snippet || '—' }}</p>
                          <ul class="cannibal-headings" *ngIf="cannibalWinnerPreview(row).headings?.length">
                            <li *ngFor="let h of cannibalWinnerPreview(row).headings.slice(0, 8)">{{ h }}</li>
                          </ul>
                        </div>
                        <div class="cannibal-detail-col cannibal-detail-col--compact-muted" *ngIf="!cannibalShowStrongerUrlColumn(row)">
                          <h4 class="cannibal-detail-label">Merge target</h4>
                          <p class="cannibal-snippet">
                            Not applicable — this decision does not consolidate into a stronger URL (delete weaker URL, or keep &amp;
                            improve the weaker page).
                          </p>
                        </div>
                      </div>

                      <div class="cannibal-dm-compact">
                        <div class="cannibal-dm-row cannibal-dm-row--signals">
                          <div class="cannibal-dm-signal-stack">
                            <div class="cannibal-dm-signal-line">
                              <span class="cannibal-dm-label">Backlinks</span>
                              <span class="cannibal-dm-value">—</span>
                            </div>
                            <div class="cannibal-dm-signal-line">
                              <span class="cannibal-dm-label">Impressions</span>
                              <span class="cannibal-dm-value">{{
                                row.signals.trafficLow != null ? (row.signals.trafficLow | number : '1.0-0') : '—'
                              }}</span>
                            </div>
                            <div class="cannibal-dm-signal-line">
                              <span class="cannibal-dm-label">Rankings</span>
                              <span class="cannibal-dm-value">{{
                                row.signals.loserRankedKeywordsCount != null
                                  ? (row.signals.loserRankedKeywordsCount | number : '1.0-0')
                                  : '—'
                              }}</span>
                            </div>
                          </div>
                          <span
                            class="cannibal-dm-pill cannibal-dm-pill--signals"
                            [ngClass]="
                              cannibalDmWeakerSignalsMergeOrKeep(row) ? 'cannibal-dm-pill--good' : 'cannibal-dm-pill--bad'
                            "
                            [attr.title]="
                              cannibalDmWeakerSignalsMergeOrKeep(row) ? cannibalDmHintMerge : cannibalDmHintLow
                            "
                            >{{ cannibalDmWeakerSignalsMergeOrKeep(row) ? 'MERGE OR KEEP' : 'LOW VALUE PAGE' }}</span
                          >
                        </div>
                        <div class="cannibal-dm-row">
                          <span class="cannibal-dm-label">Last updated</span>
                          <span class="cannibal-dm-value">
                            <ng-container *ngIf="cannibalLoserLastContentModifiedIso(row) as lmIso">{{
                              lmIso | date : 'mediumDate'
                            }}</ng-container>
                            <ng-container *ngIf="!cannibalLoserLastContentModifiedIso(row)">—</ng-container>
                          </span>
                          <ng-container *ngIf="cannibalDmLastUpdatedIsRecent(row); else dmLastStale">
                            <span class="cannibal-dm-pill cannibal-dm-pill--warn" [attr.title]="cannibalDmHintRecent"
                              >RECENTLY UPDATED</span
                            >
                          </ng-container>
                          <ng-template #dmLastStale>
                            <span class="cannibal-dm-pill cannibal-dm-pill--good" [attr.title]="cannibalDmHintStale"
                              >CAN BE UPDATED FIRST</span
                            >
                          </ng-template>
                        </div>
                        <div class="cannibal-dm-row">
                          <span class="cannibal-dm-label">Word count</span>
                          <span class="cannibal-dm-value">{{
                            row.preview.loserWordCount != null
                              ? (row.preview.loserWordCount | number : '1.0-0')
                              : '—'
                          }}</span>
                          <ng-container *ngIf="!cannibalDmWordCountThin(row); else dmThinWc">
                            <span class="cannibal-dm-pill cannibal-dm-pill--good" [attr.title]="cannibalDmHintNotThin"
                              >LENGTH OK</span
                            >
                          </ng-container>
                          <ng-template #dmThinWc>
                            <span class="cannibal-dm-pill cannibal-dm-pill--bad" [attr.title]="cannibalDmHintThin"
                              >THIN CONTENT</span
                            >
                          </ng-template>
                        </div>
                        <h5 class="cannibal-dm-subheading cannibal-dm-subheading--intent">
                          CHECK INTENT <span class="cannibal-dm-tag">MANUAL</span>
                        </h5>
                        <p class="cannibal-dm-muted">
                          We don’t score SERP intent automatically yet—compare the weaker page to live results for your target queries (titles, H1s, angle).
                        </p>
                        <ul class="cannibal-dm-manual-list">
                          <li>If intent is <strong>wrong</strong> for queries you care about, decide whether another URL already serves the right intent.</li>
                          <li>
                            <strong>Wrong intent</strong> and <strong>this stronger candidate</strong> matches SERP intent → lean toward <strong>merge</strong> (fold content + 301 weaker URL).
                          </li>
                          <li>
                            <strong>Wrong intent</strong> and <strong>no</strong> page on the site matches SERP intent → lean toward <strong>rewrite</strong> (or create the right page first—then redirect thin URLs).
                          </li>
                        </ul>
                        <div class="cannibal-dm-notes-wrap">
                          <label class="cannibal-dm-notes-label" [attr.for]="'cannibal-notes-' + row.suggestionKey"
                            >Notes (optional)</label
                          >
                          <textarea
                            [id]="'cannibal-notes-' + row.suggestionKey"
                            class="cannibal-dm-notes"
                            rows="2"
                            [ngModel]="cannibalNotesDraft[row.suggestionKey] || ''"
                            (ngModelChange)="onCannibalNotesInput(row, $event)"
                            [disabled]="cannibalUpdatingKey === row.suggestionKey"
                            placeholder="Why you made this call (optional)…"
                            autocomplete="off"
                          ></textarea>
                          <div
                            class="cannibal-dm-notes-actions"
                            *ngIf="row.status === 'done' && row.cannibalResolution"
                          >
                            <button
                              type="button"
                              class="cannibal-dm-save-note"
                              (click)="saveCannibalDecisionNotes(row)"
                              [disabled]="cannibalUpdatingKey === row.suggestionKey"
                            >
                              Save note
                            </button>
                          </div>
                        </div>
                        <div class="cannibal-dm-actions" role="group" aria-label="Record decision for this cannibalization pair">
                          <button
                            type="button"
                            class="cannibal-dm-btn cannibal-dm-btn--delete"
                            (click)="setCannibalPairResolution(row, 'delete')"
                            [disabled]="cannibalUpdatingKey === row.suggestionKey"
                            [class.cannibal-dm-btn--active]="row.status === 'done' && row.cannibalResolution === 'delete'"
                          >
                            DELETE
                          </button>
                          <button
                            type="button"
                            class="cannibal-dm-btn cannibal-dm-btn--merge"
                            (click)="setCannibalPairResolution(row, 'merge_redirect')"
                            [disabled]="cannibalUpdatingKey === row.suggestionKey"
                            [class.cannibal-dm-btn--active]="row.status === 'done' && row.cannibalResolution === 'merge_redirect'"
                          >
                            MERGE &amp; REDIRECT
                          </button>
                          <button
                            type="button"
                            class="cannibal-dm-btn cannibal-dm-btn--keep"
                            (click)="setCannibalPairResolution(row, 'keep_improve')"
                            [disabled]="cannibalUpdatingKey === row.suggestionKey"
                            [class.cannibal-dm-btn--active]="row.status === 'done' && row.cannibalResolution === 'keep_improve'"
                          >
                            KEEP &amp; IMPROVE
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </section>
      </div>

      <section class="cannibal-dismissed-section" *ngIf="!cannibalLoading && cannibalDismissedRows.length > 0">
        <h3 class="cannibal-dismissed-title">Dismissed (not in worklist or export)</h3>
        <p class="cannibal-dismissed-hint">
          Use <strong>Refresh all</strong> above to clear every saved decision (including these) and reload.
        </p>
        <div class="cannibal-table-wrap">
          <table class="action-plan-table-compact cannibal-table">
            <thead>
              <tr>
                <th>Weaker URL</th>
                <th>Stronger URL</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of cannibalDismissedRows; trackBy: trackCannibalRow">
                <td>
                  <a class="url-text external-link" [href]="cannibalLoserUrl(row)" target="_blank" rel="noopener noreferrer">
                    {{ formatUrl(cannibalLoserUrl(row), false) }}
                  </a>
                </td>
                <td>
                  <a class="url-text external-link" [href]="cannibalWinnerUrl(row)" target="_blank" rel="noopener noreferrer">
                    {{ formatUrl(cannibalWinnerUrl(row), false) }}
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>
  </ng-container>

  <!-- Renders on Cannibalization tab: keep outside the `pages` *ngIf or the popover is not in the DOM. -->
  <div
    class="cannibal-incoming-global-popover"
    *ngIf="cannibalIncomingPopover.open"
    [style.left.px]="cannibalIncomingPopover.left"
    [style.top.px]="cannibalIncomingPopover.top"
    (mouseenter)="cancelCannibalIncomingPopoverHide()"
    (mouseleave)="scheduleCannibalIncomingPopoverHide()"
    role="tooltip"
  >
    <div class="cannibal-incoming-popover-title">{{ cannibalIncomingPopover.title }}</div>
    <div class="cannibal-incoming-popover-list">
      <div class="cannibal-incoming-popover-row" *ngFor="let link of cannibalIncomingPopover.rows">
        <a class="cannibal-incoming-popover-src" [href]="link.sourceUrl" target="_blank" rel="noopener noreferrer">{{
          formatUrl(link.sourceUrl, false)
        }}</a>
        <span class="cannibal-incoming-popover-meta" *ngIf="link.sourcePageTitle">{{ link.sourcePageTitle }}</span>
        <span class="cannibal-incoming-popover-anchor">{{ link.anchorText || '—' }}</span>
        <span class="cannibal-incoming-popover-flags" *ngIf="link.isBroken || link.dofollow === false">
          <span *ngIf="link.isBroken" class="cannibal-incoming-flag">Broken</span>
          <span *ngIf="link.dofollow === false" class="cannibal-incoming-flag">Nofollow</span>
        </span>
      </div>
      <p *ngIf="cannibalIncomingPopover.rows.length === 0" class="cannibal-incoming-popover-empty">No links of this type.</p>
    </div>
  </div>

  <div
    class="cannibal-backlinks-global-popover"
    *ngIf="cannibalBacklinksPopover.open"
    [style.left.px]="cannibalBacklinksPopover.left"
    [style.top.px]="cannibalBacklinksPopover.top"
    (mouseenter)="cancelCannibalBacklinksPopoverHide()"
    (mouseleave)="scheduleCannibalBacklinksPopoverHide()"
    role="tooltip"
  >
    <div class="cannibal-backlinks-popover-title">External backlinks</div>
    <p class="cannibal-backlinks-popover-body">
      Referring domains / external backlink counts are not wired up yet. This pill reserves space for the weaker URL so you can
      compare merge vs delete once we ingest backlink data (e.g. via DataForSEO or your link graph).
    </p>
    <p class="cannibal-backlinks-popover-note" *ngIf="environment.featureFlags.cannibalBacklinksPreviewHighlight">
      Preview styling is on in non-production builds.
    </p>
  </div>

  <ng-container *ngIf="inventorySection === 'pages'">
<!-- Loading State (single-column mode only; compare mode uses per-panel spinners) -->
<div class="inventory-container" *ngIf="loading && !isCompareTopicMode">
  <div class="loading-state">
    <div class="loading-spinner"></div>
    <p>Loading content inventory…</p>
  </div>
</div>

<!-- Error State (single-column mode only) -->
<div class="inventory-container" *ngIf="error && !loading && !isCompareTopicMode">
  <div class="error-state">
    <div class="error-icon">⚠️</div>
    <h2>Something went wrong</h2>
    <p>{{ error }}</p>
    <button class="btn-primary" (click)="loadInventory()">Try Again</button>
  </div>
</div>

<!-- Empty State (no pages analyzed yet) -->
<div class="inventory-container" *ngIf="isEmpty">
  <div class="empty-state">
    <div class="empty-icon">📋</div>
    <h1>No pages analyzed yet<span *ngIf="selectedDomain"> on {{ selectedDomain }}</span></h1>
    <p class="empty-subtitle">Run a page comparison to start building your content inventory for this domain.</p>
    <a routerLink="/page-comparison" class="btn-primary btn-lg">Compare Two Pages</a>
  </div>
</div>

<!-- Content -->
<div
  class="inventory-container"
  [class.inventory-container-compare]="isCompareTopicMode"
  [class.inventory-container--fab-pad]="!isCompareTopicMode && bulkClusterSelectionCount > 0"
  *ngIf="!isEmpty && (isCompareTopicMode || (!loading && !error))"
>
  <header class="inventory-header">
    <div class="header-text">
      <h1>Content Inventory</h1>
      <p class="header-subtitle" *ngIf="!isCompareTopicMode">
        {{ pagination.total }} analyzed page{{ pagination.total === 1 ? '' : 's' }}
        <span *ngIf="selectedDomain"> on {{ selectedDomain }}</span>
      </p>
      <p class="header-subtitle" *ngIf="isCompareTopicMode">
        Same topic, search, and sort for both domains; each column has its own pagination.
        On narrower screens, panels stack so each table can use the full width. Scroll inside a panel if columns do not fit.
      </p>
    </div>
  </header>

  <!-- Search & Controls: primary filters + expandable advanced filters (solo Pages). -->
  <div class="controls-bar">
    <div class="controls-row controls-row-primary">
    <div class="tracking-filter" *ngIf="selectedDomain">
      <span class="tracking-filter-label">Tracking</span>
      <div class="tracking-filter-segments" role="tablist" aria-label="Tracking filter">
        <button type="button" class="tracking-filter-segment" [class.tracking-filter-segment--active]="trackingFilter === 'tracked'" (click)="updateTrackingFilter('tracked')">Tracked</button>
        <button type="button" class="tracking-filter-segment" [class.tracking-filter-segment--active]="trackingFilter === 'excluded'" (click)="updateTrackingFilter('excluded')">Excluded</button>
        <button type="button" class="tracking-filter-segment" [class.tracking-filter-segment--active]="trackingFilter === 'all'" (click)="updateTrackingFilter('all')">All</button>
      </div>
    </div>

    <div class="tracking-filter health-filter" *ngIf="selectedDomain">
      <span class="tracking-filter-label">Health</span>
      <div class="tracking-filter-segments" role="group" aria-label="Health filter">
        <button
          type="button"
          class="tracking-filter-segment"
          *ngFor="let band of healthFilterBandOptions"
          [class.tracking-filter-segment--active]="isHealthBandFilterSelected(band)"
          (click)="toggleHealthBandFilter(band)"
        >
          {{ healthFilterLabel(band) }}
        </button>
      </div>
    </div>

    <div class="path-prefix-filter" *ngIf="!isCompareTopicMode && selectedDomain">
      <span class="path-prefix-label">Path</span>
      <p class="path-prefix-hint">Optional. Subfolders: listed only if some URL uses /segment/…. <strong>Homepage</strong> = path / only. <strong>Top-level</strong> = one path segment (e.g. /browserstack), not /a/b. Topic filter still applies. OR across selections.</p>
      <div class="path-prefix-chips">
        <button
          type="button"
          class="path-prefix-chip"
          *ngFor="let p of primaryPathChipOptions()"
          [class.path-prefix-chip--active]="isPathPrefixSelected(p, 'primary')"
          (click)="togglePathPrefix(p, 'primary')"
        >
          {{ pathPrefixChipLabel(p) }}
        </button>
      </div>
      <span class="path-prefix-status" *ngIf="loadingPathPrefixes">Loading paths…</span>
      <span class="path-prefix-status path-prefix-error" *ngIf="!loadingPathPrefixes && pathPrefixError">{{ pathPrefixError }}</span>
    </div>
    </div>

    <div class="controls-row controls-row-search">
    <div class="search-box search-box--full">
      <span class="search-icon">🔍</span>
      <input
        type="text"
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchChange()"
        placeholder="Search by URL…"
        class="search-input"
      />
    </div>
    <div class="columns-picker" data-column-picker-root>
      <button
        type="button"
        class="btn-secondary btn-sm columns-picker-trigger"
        [attr.aria-expanded]="columnPickerOpen"
        (click)="toggleColumnPicker($event)"
      >
        Columns
      </button>
      <div class="columns-picker-menu" *ngIf="columnPickerOpen" (click)="$event.stopPropagation()">
        <div class="columns-picker-title">Show columns</div>
        <label class="columns-picker-item" *ngFor="let option of columnOptions">
          <input
            type="checkbox"
            [checked]="isColumnVisible(option.key)"
            [disabled]="!isColumnOptionAvailable(option)"
            (change)="toggleColumnVisibility(option.key, $event)"
          />
          <span>{{ option.label }}</span>
        </label>
        <p class="columns-picker-hint" *ngIf="!hasTopicScope">
          Topic columns activate when a topic filter is selected.
        </p>
        <button type="button" class="columns-picker-close" (click)="closeColumnPicker($event)">Done</button>
      </div>
    </div>
    <button
      type="button"
      class="btn-secondary btn-sm pages-filters-toggle"
      *ngIf="usePagesFilterCollapse()"
      [attr.aria-expanded]="pagesFiltersExpanded"
      (click)="togglePagesFiltersExpanded()"
    >
      Filters
    </button>
    <span class="cluster-filter-draft-hint" *ngIf="usePagesFilterCollapse() && clusterFilterApplyVisible">
      Cluster filter not applied — open Filters to apply.
    </span>
    </div>

    <div class="controls-row controls-row-expanded" *ngIf="!usePagesFilterCollapse() || pagesFiltersExpanded">
    <div class="topic-filter" [class.topic-filter--full-row]="isCompareTopicMode">
      <label for="inventory-topic-filter" class="topic-filter-label">Topic</label>
      <label class="topic-subtopic-toggle">
        <input
          type="checkbox"
          [(ngModel)]="includeChildTopics"
          (ngModelChange)="onIncludeChildTopicsChange()"
          [disabled]="loadingTopics || !selectedDomain"
        />
        <span>Include subtopics</span>
      </label>
      <div class="topic-typeahead">
        <input
        id="inventory-topic-filter"
        class="topic-filter-input"
        type="text"
        [ngModel]="topicSearchQuery"
        (ngModelChange)="topicSearchQuery = $event; onTopicInputChange()"
        (focus)="onTopicInputFocus()"
        (blur)="onTopicInputBlur()"
        (keydown.enter)="applyTopicFromInput(); $event.preventDefault()"
        placeholder="All topics"
        [disabled]="loadingTopics || !selectedDomain"
        autocomplete="off"
      />
      <button
        type="button"
        class="topic-clear-btn"
        *ngIf="selectedTopicSlug || topicSearchQuery.trim()"
        (mousedown)="clearTopicFilter()"
        [disabled]="loadingTopics || !selectedDomain"
      >
        Clear
      </button>

      <div class="topic-suggestions" *ngIf="showTopicSuggestions && !loadingTopics && visibleTopicSuggestions.length > 0">
        <button
          type="button"
          class="topic-suggestion all-topics"
          (mousedown)="clearTopicFilter()"
        >
          <span class="topic-suggestion-label">All topics</span>
        </button>
        <div
          class="topic-suggestion-shell"
          *ngFor="let topic of visibleTopicSuggestions"
          (mouseenter)="onTopicSuggestionRowEnter(topic)"
          (mouseleave)="onTopicSuggestionRowLeave()"
        >
          <button type="button" class="topic-suggestion" (mousedown)="selectTopic(topic)">
            <span class="topic-suggestion-main">
              <span class="topic-suggestion-label">{{ topic.label }}</span>
              <span class="topic-suggestion-parent" *ngIf="topic.topicType === 'child'">in {{ topic.parentLabel }}</span>
              <span class="topic-suggestion-alias" *ngIf="topic.aliasLabels && topic.aliasLabels.length > 0">
                also {{ topic.aliasLabels.join(', ') }}
              </span>
            </span>
            <span class="topic-suggestion-tags">
              <span class="topic-kind-tag" [ngClass]="topicKindTagClass(topic)">
                {{ topic.topicType === 'child' ? 'Child' : 'Parent' }}
              </span>
              <span class="topic-authority-tag" [ngClass]="topicAuthorityTagClass(topic.authorityScore)">
                {{ formatAuthorityScore(topic.authorityScore) }}
              </span>
            </span>
          </button>
          <div class="topic-suggestion-competitors" *ngIf="topicSuggestionCompetitorEntry(topic.slug) as comp">
            <span class="topic-suggestion-comp-label">Competitors</span>
            <ng-container [ngSwitch]="comp.status">
              <span *ngSwitchCase="'loading'" class="topic-suggestion-comp-loading">Loading scores…</span>
              <span *ngSwitchCase="'error'" class="topic-suggestion-comp-error">{{ comp.error }}</span>
              <ng-container *ngSwitchCase="'ready'">
                <p *ngIf="!comp.rows?.length" class="topic-suggestion-comp-empty">
                  You have no marked competitors yet. Open the header <strong>Competitors</strong> menu to add domains; we use the same Domain Topics authority score as for your active domain (when that competitor has URLs and aggregates in this workspace).
                </p>
                <div class="topic-suggestion-comp-chips" *ngIf="comp.rows?.length">
                  <ng-container *ngFor="let row of comp.rows">
                    <span
                      *ngIf="row.kind === 'ready'"
                      class="topic-suggestion-comp-chip topic-suggestion-comp-chip--ready"
                      role="button"
                      tabindex="0"
                      (mousedown)="compareWithTopicFromDropdown(row.domain, topic, $event)"
                      [class.topic-suggestion-comp-chip--disabled]="isSavingCompareFromTopicPill"
                    >
                      <span class="topic-suggestion-comp-chip-domain">{{ row.domain }}</span>
                      <span
                        class="topic-suggestion-comp-chip-score topic-authority-tag"
                        [ngClass]="topicAuthorityTagClass(row.authorityScore)"
                      >
                        {{ formatAuthorityScore(row.authorityScore) }}
                      </span>
                    </span>
                    <span
                      *ngIf="row.kind === 'unavailable'"
                      class="topic-suggestion-comp-chip topic-suggestion-comp-chip--muted"
                      [title]="row.message"
                    >
                      <span class="topic-suggestion-comp-chip-domain">{{ row.domain }}</span>
                      <span class="topic-suggestion-comp-chip-dash">—</span>
                    </span>
                  </ng-container>
                </div>
                <p class="topic-suggestion-comp-footnote">
                  Scores load after ~120ms hover to limit API traffic. Muted “—” means no score: hover or focus the chip for the full reason (workspace URL requirement, missing aggregates, or topic not on that domain).
                </p>
              </ng-container>
            </ng-container>
          </div>
        </div>
        <p class="topic-suggestions-hover-hint" *ngIf="visibleTopicSuggestions.length">
          Hover a topic row to load each <strong>marked competitor’s</strong> authority on that topic (same 0–100 score as the picker). Click a green chip to compare side-by-side.
        </p>
      </div>
      </div>
      <span class="topic-filter-status" *ngIf="loadingTopics">Loading topics...</span>
      <span class="topic-filter-status topic-filter-error" *ngIf="!loadingTopics && topicError">{{ topicError }}</span>

      <div
        class="topic-competitor-strip"
        *ngIf="showTopicCompetitorStrip"
        role="region"
        aria-label="Compare topic with marked competitors"
      >
        <div class="topic-competitor-strip-head">
          <span class="topic-competitor-strip-label">Compare · marked competitors</span>
          <span class="topic-competitor-strip-hint">Authority matches the topic list above. Click a domain to open side-by-side inventory.</span>
        </div>

        <p class="topic-competitor-strip-loading" *ngIf="competitorTopicPillsLoading">Loading competitor topic scores…</p>

        <p class="topic-competitor-strip-error topic-filter-error" *ngIf="!competitorTopicPillsLoading && competitorTopicPillsSettingsError">
          {{ competitorTopicPillsSettingsError }}
        </p>

        <p class="topic-competitor-strip-error topic-filter-error" *ngIf="!competitorTopicPillsLoading && compareTopicPillSaveError">
          {{ compareTopicPillSaveError }}
        </p>

        <div class="topic-competitor-strip-no-marked" *ngIf="!competitorTopicPillsLoading && competitorTopicPillsNoMarked">
          <p>
            You have no <strong>marked competitors</strong> yet. Use the header <strong>Competitors</strong> menu to add domains you want to compare.
            For each competitor that has URLs in this workspace and aggregated Domain Topics, we show the same topic authority score as in the picker above.
          </p>
          <p *ngIf="featureFlags.isEnabled('competitorFinder')">
            You can also run <a routerLink="/competitor-finder" class="topic-competitor-strip-link">Competitor Finder</a> to discover candidates, then mark them in the header.
          </p>
        </div>

        <div class="topic-competitor-pills" *ngIf="!competitorTopicPillsLoading && competitorTopicPills.length > 0">
          <ng-container *ngFor="let pill of competitorTopicPills">
            <button
              *ngIf="pill.kind === 'ready'"
              type="button"
              class="topic-competitor-pill topic-competitor-pill--ready"
              (click)="selectCompareDomainFromTopicPill(pill.domain)"
              [disabled]="isSavingCompareFromTopicPill"
            >
              <span class="topic-competitor-pill-domain">{{ pill.domain }}</span>
              <span
                class="topic-competitor-pill-score topic-authority-tag"
                [ngClass]="topicAuthorityTagClass(pill.authorityScore)"
              >
                {{ formatAuthorityScore(pill.authorityScore) }}
              </span>
            </button>
            <div *ngIf="pill.kind === 'unavailable'" class="topic-competitor-pill topic-competitor-pill--unavailable">
              <span class="topic-competitor-pill-domain">{{ pill.domain }}</span>
              <p class="topic-competitor-pill-reason">{{ pill.message }}</p>
            </div>
          </ng-container>
        </div>
      </div>
    </div>

    <div class="dev-traffic-actions" *ngIf="isDevView() && selectedDomain">
      <button
        type="button"
        class="btn-secondary btn-sm"
        (click)="runTrafficRefreshForActiveDomain()"
        [disabled]="trafficRefreshRunning"
      >
        {{ trafficRefreshRunning ? 'Refreshing traffic…' : 'Refresh est. traffic (dev)' }}
      </button>
      <button
        type="button"
        class="btn-secondary btn-sm"
        (click)="runRankedKeywordsRefreshForActiveDomain()"
        [disabled]="rankedKwDevRunning || !selectedDomain"
      >
        {{ rankedKwDevRunning ? 'Refreshing keywords…' : 'Refresh est. keywords (dev)' }}
      </button>
      <button
        type="button"
        class="btn-secondary btn-sm"
        (click)="runDemandLabelRefreshForActiveDomain()"
        [disabled]="demandLabelRefreshRunning || !selectedDomain"
      >
        {{ demandLabelRefreshRunning ? 'Refreshing demand…' : 'Refresh page demand (dev)' }}
      </button>
      <span class="dev-serp-refresh-group">
        <button
          type="button"
          class="btn-secondary btn-sm"
          (click)="runUrlSerpRefreshForActiveDomain()"
          [disabled]="urlSerpRefreshRunning || !selectedDomain"
        >
          {{ urlSerpRefreshRunning ? 'Refreshing SERP…' : 'Refresh URL SERP (dev)' }}
        </button>
        <label class="dev-serp-force-label" title="Re-fetch SERP and keyword difficulty from API (bypass TopicSerp + KeywordDifficultyCache). ~$0.002/SERP + ~$0.01/batch KD per chunk.">
          <input
            type="checkbox"
            [(ngModel)]="urlSerpForceRefresh"
            [disabled]="urlSerpRefreshRunning"
          />
          Force API
        </label>
      </span>
    </div>

    <div
      class="cannibal-rkw-progress url-serp-dev-progress"
      *ngIf="urlSerpRefreshRunning && urlSerpRefreshProgress"
      role="status"
      aria-live="polite"
    >
      <div class="cannibal-rkw-progress-bar-wrap">
        <div class="cannibal-rkw-progress-bar">
          <div class="cannibal-rkw-progress-fill" [style.width.%]="urlSerpRefreshProgress.percent"></div>
        </div>
      </div>
      <div class="cannibal-rkw-progress-meta">
        <span class="cannibal-rkw-progress-line">{{ urlSerpRefreshProgress.statusLine }}</span>
        <span class="cannibal-rkw-eta" *ngIf="urlSerpRefreshProgress.etaLabel">{{ urlSerpRefreshProgress.etaLabel }}</span>
      </div>
    </div>

    <div class="controls-row controls-row-clusters" *ngIf="!isCompareTopicMode && selectedDomain && planClusters.length > 0">
      <div class="cluster-filter-block" data-cluster-filter-root>
        <div class="cluster-filter-head">
          <div class="cluster-filter-title">
            <span class="cluster-filter-label">Cluster filter</span>
            <span class="cluster-filter-subtitle">Find pages…</span>
          </div>
        </div>

        <div class="cluster-filter-rules">
          <div class="cluster-filter-rule" *ngFor="let rule of clusterFilterRules; let i = index; trackBy: trackClusterFilterRule">
            <div class="cluster-rule-row">
              <div class="cluster-rule-join" *ngIf="i > 0">
                <label class="visually-hidden" [attr.for]="'cluster-rule-join-' + rule.uid">Combine with previous rule</label>
                <select
                  class="cluster-rule-join-select"
                  [id]="'cluster-rule-join-' + rule.uid"
                  [(ngModel)]="rule.join"
                  (ngModelChange)="setClusterRuleJoin(rule, $event)"
                >
                  <option [ngValue]="'and'">AND</option>
                  <option [ngValue]="'or'">OR</option>
                </select>
              </div>

              <div class="cluster-rule-mode">
                <label class="visually-hidden" [attr.for]="'cluster-rule-mode-' + rule.uid">Cluster rule mode</label>
                <select
                  class="cluster-rule-mode-select"
                  [id]="'cluster-rule-mode-' + rule.uid"
                  [(ngModel)]="rule.mode"
                  (ngModelChange)="setClusterRuleMode(rule, $event)"
                >
                  <option [ngValue]="'or'">IN</option>
                  <option [ngValue]="'not'">NOT IN</option>
                </select>
              </div>

              <div class="cluster-rule-dropdown-wrap">
                <button
                  type="button"
                  class="cluster-rule-trigger"
                  (click)="toggleClusterFilterDropdown(rule.uid, $event)"
                  [attr.aria-expanded]="clusterFilterOpenRuleUid === rule.uid"
                >
                  <span class="cluster-rule-trigger-text" *ngIf="rule.topicIds.length === 0">Select clusters…</span>
                  <span class="clusters-tags clusters-tags--trigger" *ngIf="rule.topicIds.length > 0">
                    <span class="cluster-tag" *ngFor="let id of rule.topicIds">{{ planClusterById(id)?.label || 'Cluster' }}</span>
                  </span>
                  <span class="cluster-rule-chevron" aria-hidden="true"></span>
                </button>

                <div
                  class="cluster-rule-menu"
                  *ngIf="clusterFilterOpenRuleUid === rule.uid"
                  data-cluster-filter-menu
                  (click)="$event.stopPropagation()"
                >
                  <div class="cluster-rule-menu-search">
                    <input
                      type="text"
                      [(ngModel)]="rule.searchQuery"
                      class="cluster-rule-menu-input"
                      placeholder="Search clusters…"
                    />
                  </div>
                  <ul class="cluster-rule-menu-list" role="list" [attr.aria-multiselectable]="true">
                    <li class="cluster-rule-menu-item" *ngFor="let c of clustersForClusterFilterRule(rule)">
                      <label class="cluster-rule-menu-toggle">
                        <input
                          type="checkbox"
                          [checked]="isClusterSelectedInRule(rule, c.id)"
                          (change)="toggleClusterInRule(rule, c.id, $event)"
                        />
                        <span>{{ c.label }}</span>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>

              <button
                type="button"
                class="btn-secondary cluster-rule-remove"
                *ngIf="clusterFilterRules.length > 1"
                (click)="removeClusterFilterRule(i)"
              >
                Remove
              </button>
            </div>
          </div>
        </div>

        <div class="cluster-filter-actions">
          <button type="button" class="btn-primary cluster-filter-apply" *ngIf="clusterFilterApplyVisible" (click)="applyClusterFilterDraft()">Apply</button>
          <button type="button" class="cluster-filter-add-rules" (click)="addClusterFilterRule()">+ Add rules</button>
        </div>
        <p class="cluster-filter-hint">Between rows: <span class="cluster-filter-hint-mono">AND</span> / <span class="cluster-filter-hint-mono">OR</span>. Within a row: <span class="cluster-filter-hint-mono">IN</span> or <span class="cluster-filter-hint-mono">NOT IN</span> the selected clusters. Use Apply to refresh the table.</p>
      </div>
    </div>
    </div>
  </div>

  <!-- No results for search (single column only) -->
  <div class="empty-search" *ngIf="showGlobalEmptySearch">
    <p *ngIf="searchQuery.trim() || selectedTopicSlug || appliedClusterFilterHasSelection">
      No pages match current filters<span *ngIf="searchQuery.trim()"> for "<strong>{{ searchQuery }}</strong>"</span><span *ngIf="selectedDomain"> on {{ selectedDomain }}</span>
    </p>
    <button type="button" class="btn-secondary" (click)="clearSearchTopicAndClusterFilters()">Clear filters</button>
  </div>

  <!-- Side-by-side compare (topic + Compare To) -->
  <div
    class="inventory-compare-mode"
    *ngIf="isCompareTopicMode"
    [class.inventory-compare-mode--fab-pad]="quickCompareBothSelected || bulkClusterSelectionCount > 0"
  >
    <div class="inventory-compare-grid">
    <section class="inventory-compare-panel" aria-labelledby="inv-panel-active">
      <h2 id="inv-panel-active" class="inventory-compare-panel-title">{{ selectedDomain || 'Active domain' }}</h2>
      <p class="inventory-compare-panel-subtitle" *ngIf="!loading && !error">
        {{ pagination.total }} analyzed page{{ pagination.total === 1 ? '' : 's' }} matching filters
      </p>
      <p
        class="inventory-compare-panel-last"
        *ngIf="!loading && !error && pages.length > 0"
        [title]="'Newest analysis on this page: ' + lastAnalyzedTitle(pages)"
      >
        Last analyzed {{ lastAnalyzedSummary(pages) }}
      </p>

      <div class="inventory-panel-paths" *ngIf="selectedDomain">
        <span class="path-prefix-label">Path</span>
        <p class="path-prefix-hint path-prefix-hint--inline"><strong>Top-level</strong> = one segment (/browserstack). <strong>Homepage</strong> = / only. Topic filter still applies.</p>
        <div class="path-prefix-chips">
          <button
            type="button"
            class="path-prefix-chip"
            *ngFor="let p of primaryPathChipOptions()"
            [class.path-prefix-chip--active]="isPathPrefixSelected(p, 'primary')"
            (click)="togglePathPrefix(p, 'primary')"
          >
            {{ pathPrefixChipLabel(p) }}
          </button>
        </div>
        <span class="path-prefix-status" *ngIf="loadingPathPrefixes">Loading paths…</span>
        <span class="path-prefix-status path-prefix-error" *ngIf="!loadingPathPrefixes && pathPrefixError">{{ pathPrefixError }}</span>
      </div>

      <div class="panel-loading" *ngIf="loading">
        <div class="loading-spinner loading-spinner-sm"></div>
        <p>Loading…</p>
      </div>

      <div class="panel-error" *ngIf="!loading && error">
        <p>{{ error }}</p>
        <button type="button" class="btn-secondary" (click)="retryPrimaryInventory()">Try again</button>
      </div>

      <p class="panel-empty" *ngIf="panelHasNoRowsPrimary">
        No pages match current filters for this domain.
      </p>

      <div class="table-wrapper table-wrapper-compare" *ngIf="!loading && !error && pages.length > 0">
        <table class="inventory-table inventory-table--compare">
          <thead>
            <tr>
              <th class="col-bulk-select" scope="col">
                <span class="visually-hidden">Select for cluster</span>
              </th>
              <th class="col-quick-compare-select" scope="col">
                <span class="visually-hidden">Select for quick compare</span>
              </th>
              <th class="col-url sortable" (click)="toggleSort('url')">
                URL{{ sortIcon('url') }}
              </th>
              <th class="col-clusters" *ngIf="isColumnVisible('clusters')">Cluster</th>
              <th class="col-top-topics" *ngIf="isColumnVisible('topTopics')">Top topics</th>
              <th class="col-topic-class" *ngIf="hasTopicScope && isColumnVisible('topicClass')">Class</th>
              <th class="col-topic-relevance sortable" *ngIf="hasTopicScope && isColumnVisible('topicRelevance')" (click)="toggleSort('topicRelevanceScore')">
                Relevance{{ sortIcon('topicRelevanceScore') }}
              </th>
              <th class="col-topic-weight sortable" *ngIf="hasTopicScope && isColumnVisible('topicWeight')" (click)="toggleSort('topicWeight')">
                Weight{{ sortIcon('topicWeight') }}
              </th>
              <th class="col-keywords" *ngIf="isColumnVisible('keywords')">Keywords</th>
              <th class="col-traffic sortable" *ngIf="isColumnVisible('estimatedOrganicTraffic')" (click)="toggleSort('estimatedOrganicTraffic')">
                Est. Traffic{{ sortIcon('estimatedOrganicTraffic') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngTemplateOutlet="inventoryRows; context: { $implicit: pages, compareSimple: true, comparePanel: 'primary', bulkSelectPrimary: true }"></ng-container>
          </tbody>
        </table>
      </div>

      <div class="pagination pagination-compact" *ngIf="!loading && !error && pagination.totalPages > 1">
        <button
          class="page-btn"
          [disabled]="pagination.page <= 1"
          (click)="goToPage(pagination.page - 1)"
        >← Prev</button>
        <span class="page-info">
          Page {{ pagination.page }} of {{ pagination.totalPages }}
        </span>
        <button
          class="page-btn"
          [disabled]="pagination.page >= pagination.totalPages"
          (click)="goToPage(pagination.page + 1)"
        >Next →</button>
      </div>
    </section>

    <section class="inventory-compare-panel" aria-labelledby="inv-panel-compare">
      <h2 id="inv-panel-compare" class="inventory-compare-panel-title">{{ compareToDomain }}</h2>
      <p class="inventory-compare-panel-subtitle" *ngIf="!compareLoading && !compareError">
        {{ comparePagination.total }} analyzed page{{ comparePagination.total === 1 ? '' : 's' }} matching filters
      </p>
      <p
        class="inventory-compare-panel-last"
        *ngIf="!compareLoading && !compareError && comparePages.length > 0"
        [title]="'Newest analysis on this page: ' + lastAnalyzedTitle(comparePages)"
      >
        Last analyzed {{ lastAnalyzedSummary(comparePages) }}
      </p>

      <div class="inventory-panel-paths" *ngIf="compareToDomain">
        <span class="path-prefix-label">Path</span>
        <p class="path-prefix-hint path-prefix-hint--inline"><strong>Top-level</strong> vs <strong>Homepage</strong> — topic filter still applies.</p>
        <div class="path-prefix-chips">
          <button
            type="button"
            class="path-prefix-chip"
            *ngFor="let p of comparePathChipOptions()"
            [class.path-prefix-chip--active]="isPathPrefixSelected(p, 'compare')"
            (click)="togglePathPrefix(p, 'compare')"
          >
            {{ pathPrefixChipLabel(p) }}
          </button>
        </div>
        <span class="path-prefix-status" *ngIf="loadingComparePathPrefixes">Loading paths…</span>
        <span class="path-prefix-status path-prefix-error" *ngIf="!loadingComparePathPrefixes && comparePathPrefixError">{{ comparePathPrefixError }}</span>
      </div>

      <div class="panel-loading" *ngIf="compareLoading">
        <div class="loading-spinner loading-spinner-sm"></div>
        <p>Loading…</p>
      </div>

      <div class="panel-error" *ngIf="!compareLoading && compareError">
        <p>{{ compareError }}</p>
        <button type="button" class="btn-secondary" (click)="retryCompareInventory()">Try again</button>
      </div>

      <p class="panel-empty" *ngIf="panelHasNoRowsCompare">
        No pages match current filters for this domain.
      </p>

      <div class="table-wrapper table-wrapper-compare" *ngIf="!compareLoading && !compareError && comparePages.length > 0">
        <table class="inventory-table inventory-table--compare">
          <thead>
            <tr>
              <th class="col-bulk-select col-bulk-select--spacer" aria-hidden="true"></th>
              <th class="col-quick-compare-select" scope="col">
                <span class="visually-hidden">Select for quick compare</span>
              </th>
              <th class="col-url sortable" (click)="toggleSort('url')">
                URL{{ sortIcon('url') }}
              </th>
              <th class="col-clusters" *ngIf="isColumnVisible('clusters')">Cluster</th>
              <th class="col-top-topics" *ngIf="isColumnVisible('topTopics')">Top topics</th>
              <th class="col-topic-class" *ngIf="hasTopicScope && isColumnVisible('topicClass')">Class</th>
              <th class="col-topic-relevance sortable" *ngIf="hasTopicScope && isColumnVisible('topicRelevance')" (click)="toggleSort('topicRelevanceScore')">
                Relevance{{ sortIcon('topicRelevanceScore') }}
              </th>
              <th class="col-topic-weight sortable" *ngIf="hasTopicScope && isColumnVisible('topicWeight')" (click)="toggleSort('topicWeight')">
                Weight{{ sortIcon('topicWeight') }}
              </th>
              <th class="col-keywords" *ngIf="isColumnVisible('keywords')">Keywords</th>
              <th class="col-traffic sortable" *ngIf="isColumnVisible('estimatedOrganicTraffic')" (click)="toggleSort('estimatedOrganicTraffic')">
                Est. Traffic{{ sortIcon('estimatedOrganicTraffic') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngTemplateOutlet="inventoryRows; context: { $implicit: comparePages, compareSimple: true, comparePanel: 'compare' }"></ng-container>
          </tbody>
        </table>
      </div>

      <div class="pagination pagination-compact" *ngIf="!compareLoading && !compareError && comparePagination.totalPages > 1">
        <button
          class="page-btn"
          [disabled]="comparePagination.page <= 1"
          (click)="goToComparePage(comparePagination.page - 1)"
        >← Prev</button>
        <span class="page-info">
          Page {{ comparePagination.page }} of {{ comparePagination.totalPages }}
        </span>
        <button
          class="page-btn"
          [disabled]="comparePagination.page >= comparePagination.totalPages"
          (click)="goToComparePage(comparePagination.page + 1)"
        >Next →</button>
      </div>
    </section>
    </div>

    <div
      class="inventory-compare-floating-actions"
      *ngIf="quickCompareBothSelected || bulkClusterSelectionCount > 0"
    >
      <div class="inventory-quick-compare-actions" *ngIf="quickCompareBothSelected" aria-label="Quick compare">
        <button type="button" class="btn-primary" (click)="onQuickCompareCtaClick()">
          Quick compare
        </button>
        <button
          type="button"
          class="btn-secondary inventory-quick-compare-clear"
          (click)="clearQuickCompareSelection()"
        >
          Clear
        </button>
      </div>
      <div class="inventory-bulk-cluster-actions" *ngIf="bulkClusterSelectionCount > 0" aria-label="Add pages to cluster">
        <span class="inventory-bulk-cluster-summary">{{ bulkClusterSelectionCount }} page(s) selected</span>
        <label class="inventory-bulk-cluster-label" for="bulk-cluster-select-compare">Add to cluster</label>
        <select
          id="bulk-cluster-select-compare"
          class="inventory-bulk-cluster-select"
          [(ngModel)]="bulkTargetClusterId"
        >
          <option [ngValue]="null">Choose a cluster…</option>
          <option *ngFor="let c of planClusters" [ngValue]="c.id">{{ c.label }}</option>
        </select>
        <button
          type="button"
          class="btn-primary"
          (click)="confirmBulkAddToCluster()"
          [disabled]="!bulkTargetClusterId || isBulkSaving"
        >
          {{ isBulkSaving ? 'Adding…' : 'Add' }}
        </button>
        <label class="inventory-bulk-cluster-label" for="bulk-cluster-remove-select-compare">Remove from cluster</label>
        <select
          id="bulk-cluster-remove-select-compare"
          class="inventory-bulk-cluster-select"
          [(ngModel)]="bulkRemoveClusterId"
        >
          <option [ngValue]="null">Choose a cluster…</option>
          <option *ngFor="let c of planClusters" [ngValue]="c.id">{{ c.label }}</option>
        </select>
        <button
          type="button"
          class="btn-secondary"
          (click)="confirmBulkRemoveFromCluster()"
          [disabled]="!bulkRemoveClusterId || isBulkRemoving"
        >
          {{ isBulkRemoving ? 'Removing…' : 'Remove' }}
        </button>
        <button type="button" class="btn-secondary" (click)="clearBulkClusterSelection()">Clear selection</button>
        <button type="button" class="btn-secondary" (click)="markBulkSelectionIncluded()" [disabled]="isUpdatingInclusion">
          {{ isUpdatingInclusion ? 'Saving…' : 'Mark included' }}
        </button>
        <button type="button" class="btn-secondary" (click)="markBulkSelectionExcluded()" [disabled]="isUpdatingInclusion">
          {{ isUpdatingInclusion ? 'Saving…' : 'Mark excluded' }}
        </button>
        <p class="inventory-bulk-cluster-hint" *ngIf="planClusters.length === 0">
          No clusters yet —
          <button type="button" class="link-button" (click)="openPlanTabFromBulkHint()">Open Plan</button>
          to add a topic.
        </p>
      </div>
    </div>
  </div>

  <!-- Single-column table -->
  <div class="table-wrapper table-wrapper--pages-sticky" *ngIf="!isCompareTopicMode && pages.length > 0">
    <table class="inventory-table inventory-table--pages">
      <thead>
        <tr>
          <th class="col-bulk-select" scope="col">
            <span class="visually-hidden">Select for cluster</span>
          </th>
          <th class="col-url sortable" (click)="toggleSort('url')">
            URL{{ sortIcon('url') }}
          </th>
          <th class="col-score sortable" *ngIf="isColumnVisible('score')" (click)="toggleSort('onpageScore')">
            Score{{ sortIcon('onpageScore') }}
          </th>
          <th class="col-issues" *ngIf="isColumnVisible('issues')">Issues</th>
          <th class="col-health sortable" *ngIf="isDevView() && isColumnVisible('health')" (click)="toggleSort('health')">
            Health{{ sortIcon('health') }}
          </th>
          <th class="col-secondary-health sortable" *ngIf="isDevView() && isColumnVisible('health')" (click)="toggleSort('secondaryHealth')">
            Secondary health{{ sortIcon('secondaryHealth') }}
          </th>
          <th class="col-effective-health sortable" *ngIf="isColumnVisible('health')" (click)="toggleSort('effectiveHealth')">
            {{ isDevView() ? 'Effective health' : 'Health' }}{{ sortIcon('effectiveHealth') }}
          </th>
          <th
            class="col-realization-gap sortable"
            *ngIf="isColumnVisible('realizationGap')"
            [title]="realizationGapColumnHint"
            (click)="toggleSort('realizationGap')"
          >
            Gap{{ sortIcon('realizationGap') }}
          </th>
          <th
            class="col-realization-ratio sortable"
            *ngIf="isColumnVisible('realizationRatio')"
            [title]="realizationRatioColumnHint"
            (click)="toggleSort('realizationRatio')"
          >
            Ratio{{ sortIcon('realizationRatio') }}
          </th>
          <th
            class="col-serp-kd sortable"
            *ngIf="isColumnVisible('serpKeywordDifficulty')"
            [title]="serpKeywordDifficultyColumnHint"
            (click)="toggleSort('serpKeywordDifficulty')"
          >
            KD{{ sortIcon('serpKeywordDifficulty') }}
          </th>
          <th class="col-demand-claim" *ngIf="isColumnVisible('demandClaim')">Demand claim</th>
          <th class="col-signals" *ngIf="isColumnVisible('signals')">Signals</th>
          <th class="col-clusters" *ngIf="isColumnVisible('clusters')">Cluster</th>
          <th class="col-top-topics" *ngIf="isColumnVisible('topTopics')">Top topics</th>
          <th class="col-topic-class" *ngIf="hasTopicScope && isColumnVisible('topicClass')">
            Class
          </th>
          <th class="col-topic-relevance sortable" *ngIf="hasTopicScope && isColumnVisible('topicRelevance')" (click)="toggleSort('topicRelevanceScore')">
            Relevance{{ sortIcon('topicRelevanceScore') }}
          </th>
          <th class="col-topic-weight sortable" *ngIf="hasTopicScope && isColumnVisible('topicWeight')" (click)="toggleSort('topicWeight')">
            Weight{{ sortIcon('topicWeight') }}
          </th>
          <th class="col-keywords" *ngIf="isColumnVisible('keywords')">Keywords</th>
          <th class="col-traffic sortable" *ngIf="isColumnVisible('estimatedOrganicTraffic')" (click)="toggleSort('estimatedOrganicTraffic')">
            Est. Traffic{{ sortIcon('estimatedOrganicTraffic') }}
          </th>
          <th class="col-date sortable" *ngIf="isColumnVisible('analyzedAt')" (click)="toggleSort('analyzedAt')">
            Analyzed{{ sortIcon('analyzedAt') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngTemplateOutlet="inventoryRows; context: { $implicit: pages, bulkSelectPrimary: true }"></ng-container>
      </tbody>
    </table>
  </div>

  <div class="pagination" *ngIf="!isCompareTopicMode && pagination.totalPages > 1">
    <button
      class="page-btn"
      [disabled]="pagination.page <= 1"
      (click)="goToPage(pagination.page - 1)"
    >← Prev</button>

    <span class="page-info">
      Page {{ pagination.page }} of {{ pagination.totalPages }}
    </span>

    <button
      class="page-btn"
      [disabled]="pagination.page >= pagination.totalPages"
      (click)="goToPage(pagination.page + 1)"
    >Next →</button>
  </div>

  <div class="inventory-pages-floating-actions" *ngIf="!isCompareTopicMode && bulkClusterSelectionCount > 0">
    <div class="inventory-bulk-cluster-actions" aria-label="Add pages to cluster">
      <span class="inventory-bulk-cluster-summary">{{ bulkClusterSelectionCount }} page(s) selected</span>
      <label class="inventory-bulk-cluster-label" for="bulk-cluster-select-pages">Add to cluster</label>
      <select
        id="bulk-cluster-select-pages"
        class="inventory-bulk-cluster-select"
        [(ngModel)]="bulkTargetClusterId"
      >
        <option [ngValue]="null">Choose a cluster…</option>
        <option *ngFor="let c of planClusters" [ngValue]="c.id">{{ c.label }}</option>
      </select>
      <button
        type="button"
        class="btn-primary"
        (click)="confirmBulkAddToCluster()"
        [disabled]="!bulkTargetClusterId || isBulkSaving"
      >
        {{ isBulkSaving ? 'Adding…' : 'Add' }}
      </button>
      <label class="inventory-bulk-cluster-label" for="bulk-cluster-remove-select-pages">Remove from cluster</label>
      <select
        id="bulk-cluster-remove-select-pages"
        class="inventory-bulk-cluster-select"
        [(ngModel)]="bulkRemoveClusterId"
      >
        <option [ngValue]="null">Choose a cluster…</option>
        <option *ngFor="let c of planClusters" [ngValue]="c.id">{{ c.label }}</option>
      </select>
      <button
        type="button"
        class="btn-secondary"
        (click)="confirmBulkRemoveFromCluster()"
        [disabled]="!bulkRemoveClusterId || isBulkRemoving"
      >
        {{ isBulkRemoving ? 'Removing…' : 'Remove' }}
      </button>
      <button type="button" class="btn-secondary" (click)="clearBulkClusterSelection()">Clear selection</button>
      <button type="button" class="btn-secondary" (click)="markBulkSelectionIncluded()" [disabled]="isUpdatingInclusion">
        {{ isUpdatingInclusion ? 'Saving…' : 'Mark included' }}
      </button>
      <button type="button" class="btn-secondary" (click)="markBulkSelectionExcluded()" [disabled]="isUpdatingInclusion">
        {{ isUpdatingInclusion ? 'Saving…' : 'Mark excluded' }}
      </button>
      <p class="inventory-bulk-cluster-hint" *ngIf="planClusters.length === 0">
        No clusters yet —
        <button type="button" class="link-button" (click)="openPlanTabFromBulkHint()">Open Plan</button>
        to add a topic.
      </p>
    </div>
  </div>
</div>

<ng-template #inventoryRows let-pages let-urlCompact="urlCompact" let-compareSimple="compareSimple" let-comparePanel="comparePanel" let-bulkSelectPrimary="bulkSelectPrimary">
  <tr *ngFor="let page of pages; let i = index" class="page-row" (click)="goToUrlDetail(page.url)">
    <td *ngIf="bulkSelectPrimary" class="col-bulk-select" (click)="$event.stopPropagation()">
      <input
        type="checkbox"
        [checked]="isBulkSelected(page.url)"
        (click)="onBulkCheckboxClick(page, pages, i, $event); $event.stopPropagation()"
        [attr.aria-label]="'Select page for cluster: ' + page.url"
      />
    </td>
    <td
      *ngIf="comparePanel === 'compare' && !bulkSelectPrimary"
      class="col-bulk-select col-bulk-select--spacer"
      aria-hidden="true"
    ></td>
    <td
      *ngIf="comparePanel"
      class="col-quick-compare-select"
      (click)="$event.stopPropagation()"
    >
      <input
        type="checkbox"
        [checked]="isQuickCompareSelected(comparePanel, page.url)"
        (change)="toggleQuickCompareSelection(comparePanel, page)"
        (click)="$event.stopPropagation()"
        [attr.aria-label]="'Select this page for quick compare'"
      />
    </td>
    <td
      class="col-url"
      [class.col-url--compact]="urlCompact"
      [class.col-url--compare-full]="compareSimple"
      [title]="page.url"
    >
      <span
        class="url-text"
        [class.url-text--compact]="urlCompact"
        [class.url-text--compare-full]="compareSimple"
      >{{ formatUrl(page.url, !compareSimple) }}</span>
    </td>
    <td class="col-clusters" *ngIf="compareSimple && isColumnVisible('clusters')">
      <div class="clusters-tags" *ngIf="primaryClusterForPage(page) as clusterLabel">
        <span class="cluster-tag" [title]="clusterLabel">{{ clusterLabel }}</span>
        <button
          type="button"
          class="top-topic-overflow cluster-overflow"
          *ngIf="clusterOverflowCount(page) > 0"
          (mouseenter)="openClusterPopover(page, $event)"
          (mouseleave)="scheduleClusterPopoverHide()"
          (focus)="openClusterPopover(page, $event)"
          (blur)="scheduleClusterPopoverHide()"
          (click)="$event.stopPropagation()"
          [attr.aria-label]="'Show remaining clusters (' + clusterOverflowCount(page) + ')'"
        >
          +{{ clusterOverflowCount(page) }}
        </button>
      </div>
      <span class="clusters-empty" *ngIf="!primaryClusterForPage(page)">—</span>
    </td>
    <td class="col-top-topics" *ngIf="compareSimple && isColumnVisible('topTopics')">
      <div class="top-topics-pills" *ngIf="topTopicsForPage(page).length > 0">
        <span
          class="topic-relevance-badge top-topic-pill"
          *ngFor="let t of topTopicsForPage(page)"
          [ngClass]="topTopicPillClass(t.relevancePct)"
          [title]="t.label + ' (' + t.relevancePct + '%)'"
        >
          {{ t.label }}
        </span>
        <button
          type="button"
          class="top-topic-overflow"
          *ngIf="topTopicsOverflowCount(page) > 0"
          (mouseenter)="openTopTopicsPopover(page, $event)"
          (mouseleave)="scheduleTopTopicsPopoverHide()"
          (focus)="openTopTopicsPopover(page, $event)"
          (blur)="scheduleTopTopicsPopoverHide()"
          (click)="$event.stopPropagation()"
          [attr.aria-label]="'Show remaining topics (' + topTopicsOverflowCount(page) + ')'"
        >
          +{{ topTopicsOverflowCount(page) }}
        </button>
      </div>
      <span class="clusters-empty" *ngIf="topTopicsForPage(page).length === 0">—</span>
    </td>
    <td class="col-score" *ngIf="!compareSimple && isColumnVisible('score')">
      <span class="score-badge" [ngClass]="scoreClass(page.onpageScore)">
        {{ page.onpageScore }}
      </span>
    </td>
    <td class="col-issues" *ngIf="!compareSimple && isColumnVisible('issues')">
      <span class="issues-badge issues-badge--icons">
        <span
          class="issue-pill issue-pill--critical"
          *ngIf="page.criticalIssuesCount > 0"
          [title]="page.criticalIssuesCount + ' critical issue' + (page.criticalIssuesCount === 1 ? '' : 's')"
        >
          <span class="issue-pill-icon" aria-hidden="true">⛔</span>
          <span>{{ page.criticalIssuesCount }}</span>
        </span>
        <span
          class="issue-pill issue-pill--warning"
          *ngIf="page.warningsCount > 0"
          [title]="page.warningsCount + ' warning' + (page.warningsCount === 1 ? '' : 's')"
        >
          <span class="issue-pill-icon" aria-hidden="true">⚠</span>
          <span>{{ page.warningsCount }}</span>
        </span>
        <span
          class="issue-pill issue-pill--clean"
          *ngIf="page.criticalIssuesCount === 0 && page.warningsCount === 0"
          title="No critical issues or warnings"
        >
          Clean
        </span>
      </span>
    </td>
    <td class="col-health" *ngIf="!compareSimple && isDevView() && isColumnVisible('health')">
      <span
        class="score-badge page-health-badge"
        [ngClass]="pageHealthClass(page)"
        [title]="pageHealthTitle(page)"
      >
        {{ pageHealthLabel(page) }}
      </span>
    </td>
    <td class="col-secondary-health" *ngIf="!compareSimple && isDevView() && isColumnVisible('health')">
      <span
        class="score-badge page-health-badge"
        [ngClass]="pageSecondaryHealthClass(page)"
        [title]="pageSecondaryHealthTitle(page)"
      >
        {{ pageSecondaryHealthLabel(page) }}
      </span>
    </td>
    <td class="col-effective-health" *ngIf="!compareSimple && isColumnVisible('health')">
      <span
        class="score-badge page-health-badge"
        [ngClass]="pageEffectiveHealthClass(page)"
        [title]="pageEffectiveHealthTitle(page)"
      >
        {{ pageEffectiveHealthLabel(page) }}
      </span>
    </td>
    <td class="col-realization-gap" *ngIf="!compareSimple && isColumnVisible('realizationGap')">
      <span class="realization-metric" [title]="pageRealizationGapTitle(page)">
        {{ pageRealizationGapLabel(page) }}
      </span>
    </td>
    <td class="col-realization-ratio" *ngIf="!compareSimple && isColumnVisible('realizationRatio')">
      <span class="realization-metric" [title]="pageRealizationRatioTitle(page)">
        {{ pageRealizationRatioLabel(page) }}
      </span>
    </td>
    <td class="col-serp-kd" *ngIf="!compareSimple && isColumnVisible('serpKeywordDifficulty')">
      <span class="realization-metric serp-kd-metric" [title]="pageSerpKeywordDifficultyTitle(page)">
        {{ pageSerpKeywordDifficultyLabel(page) }}
      </span>
    </td>
    <td class="col-demand-claim" *ngIf="!compareSimple && isColumnVisible('demandClaim')">
      <div class="page-demand-cell">
        <span
          class="page-demand-claim"
          [ngClass]="pageDemandClaimClass(page)"
          [title]="isDevView() ? '' : pageDemandClaimTitle(page)"
        >
          {{ pageDemandClaimLabel(page) }}
        </span>
        <div class="page-demand-dev" *ngIf="isDevView()">
          <div class="page-demand-dev-line">Claim: {{ pageDemandClaimSourceConfidence(page) }}</div>
          <div class="page-demand-dev-line">Realization: {{ pageDemandRealizationSourceConfidence(page) }}</div>
          <div class="page-demand-dev-line">Split: {{ pageDemandSplitReasonsText(page) }}</div>
        </div>
      </div>
    </td>
    <td class="col-signals" *ngIf="!compareSimple && isColumnVisible('signals')" (click)="$event.stopPropagation()">
      <span class="page-signals-loading" *ngIf="pageSignalsLoading()">—</span>
      <div class="page-signals" *ngIf="!pageSignalsLoading() && pageSignalsFor(page).length > 0">
        <span
          class="page-signal-chip"
          *ngFor="let signal of pageSignalsFor(page)"
          [ngClass]="pageSignalChipClass(signal.kind)"
          [title]="signal.title"
        >
          {{ signal.label }}
        </span>
      </div>
      <span class="clusters-empty" *ngIf="!pageSignalsLoading() && pageSignalsFor(page).length === 0">—</span>
    </td>
    <td class="col-clusters" *ngIf="!compareSimple && isColumnVisible('clusters')">
      <div class="clusters-tags" *ngIf="primaryClusterForPage(page) as clusterLabel">
        <span class="cluster-tag" [title]="clusterLabel">{{ clusterLabel }}</span>
        <button
          type="button"
          class="top-topic-overflow cluster-overflow"
          *ngIf="clusterOverflowCount(page) > 0"
          (mouseenter)="openClusterPopover(page, $event)"
          (mouseleave)="scheduleClusterPopoverHide()"
          (focus)="openClusterPopover(page, $event)"
          (blur)="scheduleClusterPopoverHide()"
          (click)="$event.stopPropagation()"
          [attr.aria-label]="'Show remaining clusters (' + clusterOverflowCount(page) + ')'"
        >
          +{{ clusterOverflowCount(page) }}
        </button>
      </div>
      <span class="clusters-empty" *ngIf="!primaryClusterForPage(page)">—</span>
    </td>
    <td class="col-top-topics" *ngIf="!compareSimple && isColumnVisible('topTopics')">
      <div class="top-topics-pills" *ngIf="topTopicsForPage(page).length > 0">
        <span
          class="topic-relevance-badge top-topic-pill"
          *ngFor="let t of topTopicsForPage(page)"
          [ngClass]="topTopicPillClass(t.relevancePct)"
          [title]="t.label + ' (' + t.relevancePct + '%)'"
        >
          {{ t.label }}
        </span>
        <button
          type="button"
          class="top-topic-overflow"
          *ngIf="topTopicsOverflowCount(page) > 0"
          (mouseenter)="openTopTopicsPopover(page, $event)"
          (mouseleave)="scheduleTopTopicsPopoverHide()"
          (focus)="openTopTopicsPopover(page, $event)"
          (blur)="scheduleTopTopicsPopoverHide()"
          (click)="$event.stopPropagation()"
          [attr.aria-label]="'Show remaining topics (' + topTopicsOverflowCount(page) + ')'"
        >
          +{{ topTopicsOverflowCount(page) }}
        </button>
      </div>
      <span class="clusters-empty" *ngIf="topTopicsForPage(page).length === 0">—</span>
    </td>
    <td class="col-topic-class" *ngIf="hasTopicScope && isColumnVisible('topicClass')">
      <span class="topic-class-badge" [ngClass]="topicClassBadgeClass(page.topicClass)">
        {{ topicClassLabel(page.topicClass) }}
      </span>
    </td>
    <td class="col-topic-relevance" *ngIf="hasTopicScope && isColumnVisible('topicRelevance')">
      <span class="score-badge" [ngClass]="topicWeightClass(page.topicRelevanceScore)">
        {{ formatTopicRelevancePct(page.topicRelevancePct) }}
      </span>
    </td>
    <td class="col-topic-weight" *ngIf="hasTopicScope && isColumnVisible('topicWeight')">
      <span class="score-badge" [ngClass]="topicWeightClass(page.topicWeight)">
        {{ formatTopicWeight(page.topicWeight) }}
      </span>
    </td>
    <td class="col-keywords" *ngIf="isColumnVisible('keywords')">{{ page.rankedKeywordsCount ?? '—' }}</td>
    <td class="col-traffic" *ngIf="isColumnVisible('estimatedOrganicTraffic')">{{ page.estimatedOrganicTraffic != null ? (page.estimatedOrganicTraffic | number:'1.0-0') : '—' }}</td>
    <td class="col-date" *ngIf="!compareSimple && isColumnVisible('analyzedAt')">{{ timeAgo(page.analyzedAt) }}</td>
  </tr>
</ng-template>

<app-inventory-quick-compare-drawer
  [open]="quickCompareDrawerOpen"
  [primaryUrl]="quickComparePrimaryUrl"
  [compareUrl]="quickCompareCompareUrl"
  [primaryDomainLabel]="selectedDomain"
  [compareDomainLabel]="compareToDomain || ''"
  (closed)="onQuickCompareDrawerClose()"
  (openFullCompare)="onOpenFullCompareFromQuickDrawer()"
/>
<div
  class="top-topic-global-popover"
  *ngIf="topTopicsPopover.open"
  [style.left.px]="topTopicsPopover.left"
  [style.top.px]="topTopicsPopover.top"
  (mouseenter)="cancelTopTopicsPopoverHide()"
  (mouseleave)="scheduleTopTopicsPopoverHide()"
  role="tooltip"
>
  <div class="top-topic-overflow-title">More topics</div>
  <div class="top-topic-overflow-list">
    <span
      class="topic-relevance-badge top-topic-pill"
      *ngFor="let t of topTopicsPopover.topics"
      [ngClass]="topTopicPillClass(t.relevancePct)"
    >
      {{ t.label }} ({{ t.relevancePct }}%)
    </span>
  </div>
</div>
<div
  class="top-topic-global-popover cluster-global-popover"
  *ngIf="clusterPopover.open"
  [style.left.px]="clusterPopover.left"
  [style.top.px]="clusterPopover.top"
  (mouseenter)="cancelClusterPopoverHide()"
  (mouseleave)="scheduleClusterPopoverHide()"
  role="tooltip"
>
  <div class="top-topic-overflow-title">More clusters</div>
  <div class="top-topic-overflow-list">
    <span class="cluster-tag" *ngFor="let name of clusterPopover.clusters">{{ name }}</span>
  </div>
</div>
  </ng-container>
</div>
